// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  type ClientMeta,
  formDataBodySerializer,
  type Options as Options2,
  type RequestResult,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AuthV3GetAuthCodeData,
  AuthV3GetAuthCodeResponses,
  AuthV3JoinOrgByDomainData,
  AuthV3JoinOrgByDomainResponses,
  AuthV3LoginData,
  AuthV3LoginResponses,
  AuthV3LogOutData,
  AuthV3LogOutResponses,
  AuthV3RegisterData,
  AuthV3RegisterResponses,
  AuthV3SamlConsumeData,
  AuthV3SamlConsumeResponses,
  AuthValidateTokenData,
  AuthValidateTokenResponses,
  AvailableLayersListData,
  AvailableLayersListResponses,
  CivilsearchAddAgencyLinkData,
  CivilsearchAddAgencyLinkResponses,
  CivilsearchAddAgencyLogoData,
  CivilsearchAddAgencyLogoResponses,
  CivilsearchAddCivilSearchMessageData,
  CivilsearchAddCivilSearchMessageFileData,
  CivilsearchAddCivilSearchMessageFileResponses,
  CivilsearchAddCivilSearchMessageResponses,
  CivilsearchAddDataRequestFileData,
  CivilsearchAddDataRequestFileResponses,
  CivilsearchAddDataRequestNoteData,
  CivilsearchAddDataRequestNoteResponses,
  CivilsearchAddDataRequestUpdateData,
  CivilsearchAddDataRequestUpdateResponses,
  CivilsearchAddDigitizationAccessData,
  CivilsearchAddDigitizationAccessResponses,
  CivilsearchAddNewInvoiceData,
  CivilsearchAddNewInvoiceResponses,
  CivilsearchAddSupportingFileData,
  CivilsearchAddSupportingFileResponses,
  CivilsearchArchiveAgencySubGeometryData,
  CivilsearchArchiveAgencySubGeometryResponses,
  CivilsearchBulkCreateDataRequestNotesData,
  CivilsearchBulkCreateDataRequestNotesResponses,
  CivilsearchBulkUpdateDataRequestsData,
  CivilsearchBulkUpdateDataRequestsResponses,
  CivilsearchCreateAgencySubGeometryData,
  CivilsearchCreateAgencySubGeometryResponses,
  CivilsearchCreateMissiveEmailDraftData,
  CivilsearchCreateMissiveEmailDraftResponses,
  CivilsearchCreateUtilityChecksData,
  CivilsearchCreateUtilityChecksResponses,
  CivilsearchDeleteAgencyLinkData,
  CivilsearchDeleteAgencyLinkResponses,
  CivilsearchDeleteDataRequestFileData,
  CivilsearchDeleteDataRequestFileResponses,
  CivilsearchDeleteDataRequestNoteData,
  CivilsearchDeleteDataRequestNoteResponses,
  CivilsearchDeleteDataRequestUpdateData,
  CivilsearchDeleteDataRequestUpdateResponses,
  CivilsearchDeleteSupportingFileData,
  CivilsearchDeleteSupportingFileResponses,
  CivilsearchEditAgencyLinkData,
  CivilsearchEditAgencyLinkResponses,
  CivilsearchGetAgenciesData,
  CivilsearchGetAgenciesResponses,
  CivilsearchGetAgencyData,
  CivilsearchGetAgencyGeometriesData,
  CivilsearchGetAgencyGeometriesResponses,
  CivilsearchGetAgencyResponses,
  CivilsearchGetAgencySubGeometriesData,
  CivilsearchGetAgencySubGeometriesResponses,
  CivilsearchGetAiProjectDescriptionData,
  CivilsearchGetAiProjectDescriptionResponses,
  CivilsearchGetCivilSearchersData,
  CivilsearchGetCivilSearchersResponses,
  CivilsearchGetCivilSearchFileDownloadUrlData,
  CivilsearchGetCivilSearchFileDownloadUrlResponses,
  CivilsearchGetCivilSearchMessagesData,
  CivilsearchGetCivilSearchMessagesResponses,
  CivilsearchGetDataRequestData,
  CivilsearchGetDataRequestResponses,
  CivilsearchGetDataRequestsData,
  CivilsearchGetDataRequestsResponses,
  CivilsearchGetMergeHistoryData,
  CivilsearchGetMergeHistoryResponses,
  CivilsearchGetProjectData,
  CivilsearchGetProjectResponses,
  CivilsearchGetProjectUtilityChecksData,
  CivilsearchGetProjectUtilityChecksResponses,
  CivilsearchGetRecordRequestDataData,
  CivilsearchGetRecordRequestDataResponses,
  CivilsearchGetSupportingFilesData,
  CivilsearchGetSupportingFilesResponses,
  CivilsearchGetUtilityChecksByProjectData,
  CivilsearchGetUtilityChecksByProjectResponses,
  CivilsearchListFilteredAgenciesData,
  CivilsearchListFilteredAgenciesResponses,
  CivilsearchListFilteredDataRequestsData,
  CivilsearchListFilteredDataRequestsResponses,
  CivilsearchListFilteredProjectsData,
  CivilsearchListFilteredProjectsResponses,
  CivilsearchMergeAgenciesData,
  CivilsearchMergeAgenciesPreviewData,
  CivilsearchMergeAgenciesPreviewResponses,
  CivilsearchMergeAgenciesResponses,
  CivilsearchNewAgencyContactData,
  CivilsearchNewAgencyContactResponses,
  CivilsearchRemoveDigitizationAccessData,
  CivilsearchRemoveDigitizationAccessResponses,
  CivilsearchSearchOrganizationsData,
  CivilsearchSearchOrganizationsResponses,
  CivilsearchSearchProjectsData,
  CivilsearchSearchProjectsResponses,
  CivilsearchUpdateAgencyContactData,
  CivilsearchUpdateAgencyContactResponses,
  CivilsearchUpdateAgencyData,
  CivilsearchUpdateAgencyResponses,
  CivilsearchUpdateAgencySubGeometryData,
  CivilsearchUpdateAgencySubGeometryNoteData,
  CivilsearchUpdateAgencySubGeometryNoteResponses,
  CivilsearchUpdateAgencySubGeometryResponses,
  CivilsearchUpdateCivilSearchersData,
  CivilsearchUpdateCivilSearchersResponses,
  CivilsearchUpdateDataRequestData,
  CivilsearchUpdateDataRequestNoteData,
  CivilsearchUpdateDataRequestNoteResponses,
  CivilsearchUpdateDataRequestResponses,
  CivilsearchUpdateInvoiceData,
  CivilsearchUpdateInvoiceResponses,
  CivilsearchUpdateRequestAssignmentsByProjectIdData,
  CivilsearchUpdateRequestAssignmentsByProjectIdResponses,
  CivilsearchUpdateRequestFileReferencesData,
  CivilsearchUpdateRequestFileReferencesResponses,
  CommentThreadsV3CreateCommentData,
  CommentThreadsV3CreateCommentResponses,
  CommentThreadsV3CreateCommentThreadData,
  CommentThreadsV3CreateCommentThreadResponses,
  CommentThreadsV3DeleteCommentData,
  CommentThreadsV3DeleteCommentResponses,
  CommentThreadsV3DeleteCommentThreadData,
  CommentThreadsV3DeleteCommentThreadResponses,
  CommentThreadsV3GetCommentThreadData,
  CommentThreadsV3GetCommentThreadResponses,
  CommentThreadsV3ListCommentThreadsData,
  CommentThreadsV3ListCommentThreadsResponses,
  CommentThreadsV3ListTaggableUsersData,
  CommentThreadsV3ListTaggableUsersResponses,
  CommentThreadsV3ReopenCommentThreadData,
  CommentThreadsV3ReopenCommentThreadResponses,
  CommentThreadsV3ResolveCommentThreadData,
  CommentThreadsV3ResolveCommentThreadResponses,
  CommentThreadsV3RestoreCommentThreadData,
  CommentThreadsV3RestoreCommentThreadResponses,
  CommentThreadsV3UpdateCommentData,
  CommentThreadsV3UpdateCommentResponses,
  DataRefreshStatusListData,
  DataRefreshStatusListResponses,
  DataStoreMessageHandlerData,
  DataStoreMessageHandlerResponses,
  DrawingsV3ApplyChangesData,
  DrawingsV3ApplyChangesResponses,
  DrawingsV3ArchiveDrawingData,
  DrawingsV3ArchiveDrawingResponses,
  DrawingsV3CreateDrawingData,
  DrawingsV3CreateDrawingResponses,
  DrawingsV3DuplicateDrawingData,
  DrawingsV3DuplicateDrawingResponses,
  DrawingsV3GetDrawingData,
  DrawingsV3GetDrawingResponses,
  DrawingsV3GetHistoryData,
  DrawingsV3GetHistoryResponses,
  DrawingsV3ListChangesData,
  DrawingsV3ListChangesResponses,
  DrawingsV3ListDrawingsData,
  DrawingsV3ListDrawingsResponses,
  DrawingsV3RestoreDrawingData,
  DrawingsV3RestoreDrawingResponses,
  DrawingsV3UpdateDrawingData,
  DrawingsV3UpdateDrawingResponses,
  DrfCreatePaymentIntentData,
  DrfCreatePaymentIntentResponses,
  DrfExportDrfTableToExcelData,
  DrfExportDrfTableToExcelResponses,
  DrfGetDrfRequestActivitiesData,
  DrfGetDrfRequestActivitiesResponses,
  DrfListDrfRequestsData,
  DrfListDrfRequestsResponses,
  DrfRegenerateApprovalPacketData,
  DrfRegenerateApprovalPacketResponses,
  DrfSubmitRequestData,
  DrfSubmitRequestResponses,
  DrfUpdateDrfRequestData,
  DrfUpdateDrfRequestResponses,
  DrfUploadCeiiFileData,
  DrfUploadCeiiFileResponses,
  DrfValidateGoogleRecaptchaData,
  DrfValidateGoogleRecaptchaResponses,
  ExtractGetDefaultExtractProjectionData,
  ExtractGetDefaultExtractProjectionResponses,
  ExtractGetExtractProjectionsData,
  ExtractGetExtractProjectionsResponses,
  ExtractGetExtractResourcesData,
  ExtractGetExtractResourcesResponses,
  ExtractGetFiberLitBuildingsData,
  ExtractGetFiberLitBuildingsResponses,
  ExtractGetFiberRoutesData,
  ExtractGetFiberRoutesResponses,
  ExtractGetOrganizationExtractTemplatesData,
  ExtractGetOrganizationExtractTemplatesResponses,
  ExtractNotifyExtractResultData,
  ExtractNotifyExtractResultResponses,
  ExtractProjectExtractData,
  ExtractProjectExtractResponses,
  FilesAddSingleFileData,
  FilesAddSingleFileResponses,
  FilesDeleteSingleFileData,
  FilesDeleteSingleFileResponses,
  HealthTickData,
  HealthTickResponses,
  InternalActivateExtractAutomationData,
  InternalActivateExtractAutomationResponses,
  InternalAddTransactionData,
  InternalAddTransactionResponses,
  InternalArchiveExportEscalationData,
  InternalArchiveExportEscalationResponses,
  InternalAssignExtractTemplateData,
  InternalAssignExtractTemplateResponses,
  InternalClearEsriCacheData,
  InternalClearEsriCacheResponses,
  InternalComputeIntelligenceData,
  InternalComputeIntelligenceResponses,
  InternalCreateExtractAutomationData,
  InternalCreateExtractAutomationResponses,
  InternalCreateExtractTemplateData,
  InternalCreateExtractTemplateResponses,
  InternalCreateOrganizationData,
  InternalCreateOrganizationResponses,
  InternalCreateSandboxOrgData,
  InternalCreateSandboxOrgResponses,
  InternalDeleteExtractAutomationData,
  InternalDeleteExtractAutomationResponses,
  InternalGetAdminTileLayersData,
  InternalGetAdminTileLayersResponses,
  InternalGetAllOrganizationsData,
  InternalGetAllOrganizationsResponses,
  InternalGetAllUsersData,
  InternalGetAllUsersResponses,
  InternalGetDemoOrgsData,
  InternalGetDemoOrgsResponses,
  InternalGetExportEscalationData,
  InternalGetExportEscalationResponses,
  InternalGetExtractAdminStateData,
  InternalGetExtractAdminStateResponses,
  InternalGetInternalAdminUsersData,
  InternalGetInternalAdminUsersResponses,
  InternalGetOrganizationData,
  InternalGetOrganizationResponses,
  InternalGetOrganizationSubscriptionsData,
  InternalGetOrganizationSubscriptionsResponses,
  InternalGetPgeCloudSyncFoldersData,
  InternalGetPgeCloudSyncFoldersResponses,
  InternalGetSpecialDatasetSlugsData,
  InternalGetSpecialDatasetSlugsResponses,
  InternalGetSubscriptionsStatusData,
  InternalGetSubscriptionsStatusResponses,
  InternalJoinOrgAsAdminData,
  InternalJoinOrgAsAdminResponses,
  InternalListExportEscalationsData,
  InternalListExportEscalationsResponses,
  InternalListOrgProjectsAsAdmData,
  InternalListOrgProjectsAsAdmResponses,
  InternalLoadStagingLayerCatalogData,
  InternalLoadStagingLayerCatalogResponses,
  InternalPrintOrgInvoiceData,
  InternalPrintOrgInvoiceResponses,
  InternalPromoteGisConfigData,
  InternalPromoteGisConfigResponses,
  InternalRefreshTileConfigData,
  InternalRefreshTileConfigResponses,
  InternalRefreshTilesData,
  InternalRefreshTilesResponses,
  InternalResetDemoOrgData,
  InternalResetDemoOrgResponses,
  InternalRestoreGeoItemRevisionData,
  InternalRestoreGeoItemRevisionResponses,
  InternalRunAgencyLoaderData,
  InternalRunAgencyLoaderResponses,
  InternalRunExportEscalationData,
  InternalRunExportEscalationResponses,
  InternalSetUserToApprovedData,
  InternalSetUserToApprovedResponses,
  InternalSetUserToOnboardedData,
  InternalSetUserToOnboardedResponses,
  InternalSyncExtractProjectionsData,
  InternalSyncExtractProjectionsResponses,
  InternalSyncIntelligenceData,
  InternalSyncIntelligenceResponses,
  InternalToggleIsBillableData,
  InternalToggleIsBillableResponses,
  InternalTriggerDigestForProjectData,
  InternalTriggerDigestForProjectResponses,
  InternalTriggerPgeCloudSyncWorkflowData,
  InternalTriggerPgeCloudSyncWorkflowResponses,
  InternalUpdateDisabledTileLayersData,
  InternalUpdateDisabledTileLayersResponses,
  InternalUpdateExportEscalationNotesData,
  InternalUpdateExportEscalationNotesResponses,
  InternalUpdateLinkedOrganizationsData,
  InternalUpdateLinkedOrganizationsResponses,
  InternalUpdateOrganizationAccountTypeData,
  InternalUpdateOrganizationAccountTypeResponses,
  InternalUpdateOrganizationSubscriptionData,
  InternalUpdateOrganizationSubscriptionResponses,
  InternalUpdateOrgConnectbaseLookupData,
  InternalUpdateOrgConnectbaseLookupResponses,
  InternalUpdateOrgPlanData,
  InternalUpdateOrgPlanResponses,
  InternalUpdateOrgSpecialDatasetsData,
  InternalUpdateOrgSpecialDatasetsResponses,
  InternalUpdateSubscriptionContractEndsOnData,
  InternalUpdateSubscriptionContractEndsOnResponses,
  InternalUpdateTelcoAccessData,
  InternalUpdateTelcoAccessResponses,
  MiscCalculateWatershedRiskData,
  MiscCalculateWatershedRiskResponses,
  MiscGet811DataData,
  MiscGet811DataResponses,
  MiscLogEventData,
  MiscLogEventResponses,
  MiscV2GetAgenciesSummaryData,
  MiscV2GetAgenciesSummaryResponses,
  MiscV2GetParcelSuggestionsData,
  MiscV2GetParcelSuggestionsResponses,
  MiscV2GetProjectionListData,
  MiscV2GetProjectionListResponses,
  MiscV2GetZoningDetailsAtPointData,
  MiscV2GetZoningDetailsAtPointResponses,
  MiscV2IsUrbanAreaData,
  MiscV2IsUrbanAreaResponses,
  MiscV2PrintMapData,
  MiscV2PrintMapResponses,
  MiscV2TranscodeImageData,
  MiscV2TranscodeImageResponses,
  MiscV2ValidateGeometryData,
  MiscV2ValidateGeometryResponses,
  MobileVersionGetData,
  MobileVersionGetResponses,
  MobileVersionUpdateData,
  MobileVersionUpdateResponses,
  OrganizationsAddFileData,
  OrganizationsAddFileResponses,
  OrganizationsAddMembersData,
  OrganizationsAddMembersResponses,
  OrganizationsEditData,
  OrganizationsEditMemberData,
  OrganizationsEditMemberResponses,
  OrganizationsEditResponses,
  OrganizationsEditRoleData,
  OrganizationsEditRoleResponses,
  OrganizationsGetBillingSummaryData,
  OrganizationsGetBillingSummaryResponses,
  OrganizationsGetData,
  OrganizationsGetMembersData,
  OrganizationsGetMembersResponses,
  OrganizationsGetMyOrganizationsData,
  OrganizationsGetMyOrganizationsResponses,
  OrganizationsGetOrgSummaryData,
  OrganizationsGetOrgSummaryResponses,
  OrganizationsGetResponses,
  OrganizationsPrintBillingSummaryData,
  OrganizationsPrintBillingSummaryResponses,
  OrganizationsResendInviteData,
  OrganizationsResendInviteResponses,
  OrganizationsSetTestEnvOverrideData,
  OrganizationsSetTestEnvOverrideResponses,
  OrgLayerConfigGetData,
  OrgLayerConfigGetResponses,
  OrgLayerConfigUpdateData,
  OrgLayerConfigUpdateResponses,
  PreferencesUpdateProjectMemberNotificationsData,
  PreferencesUpdateProjectMemberNotificationsResponses,
  ProjectsAddFileData,
  ProjectsAddFileResponses,
  ProjectsAddParcelDetailsData,
  ProjectsAddParcelDetailsResponses,
  ProjectsCheckForSoilsRequestData,
  ProjectsCheckForSoilsRequestResponses,
  ProjectsCreateGeoItemData,
  ProjectsCreateGeoItemResponses,
  ProjectsDeleteFileData,
  ProjectsDeleteFileResponses,
  ProjectsDeleteGeoItemData,
  ProjectsDeleteGeoItemResponses,
  ProjectsEditGeoItemData,
  ProjectsEditGeoItemResponses,
  ProjectsFetchGeotechData,
  ProjectsFetchGeotechResponses,
  ProjectsGetProjectFeaturesData,
  ProjectsGetProjectFeaturesResponses,
  ProjectsGetStatePlaneZoneData,
  ProjectsGetStatePlaneZoneResponses,
  ProjectsGetZoningDataData,
  ProjectsGetZoningDataResponses,
  ProjectsListGeoItemsData,
  ProjectsListGeoItemsResponses,
  ProjectsParcelPointQueryData,
  ProjectsParcelPointQueryResponses,
  ProjectsPrintGeoItemData,
  ProjectsPrintGeoItemResponses,
  ProjectsPrintProjectPdfData,
  ProjectsPrintProjectPdfResponses,
  ProjectsRequestDataData,
  ProjectsRequestDataResponses,
  ProjectsSoilsRequestData,
  ProjectsSoilsRequestResponses,
  ProjectsUpdateFileData,
  ProjectsUpdateFileResponses,
  ProjectsV2AddCommentData,
  ProjectsV2AddCommentResponses,
  ProjectsV2AddIntelligenceCommentData,
  ProjectsV2AddIntelligenceCommentResponses,
  ProjectsV2AddMapData,
  ProjectsV2AddMapResponses,
  ProjectsV2AddMembersData,
  ProjectsV2AddMembersResponses,
  ProjectsV2AddObjectData,
  ProjectsV2AddObjectFileData,
  ProjectsV2AddObjectFileResponses,
  ProjectsV2AddObjectResponses,
  ProjectsV2AddObjectsData,
  ProjectsV2AddObjectsResponses,
  ProjectsV2AddProjectData,
  ProjectsV2AddProjectResponses,
  ProjectsV2ArchiveCommentData,
  ProjectsV2ArchiveCommentResponses,
  ProjectsV2ArchiveProjectData,
  ProjectsV2ArchiveProjectResponses,
  ProjectsV2DeleteIntelligenceCommentData,
  ProjectsV2DeleteIntelligenceCommentResponses,
  ProjectsV2DeleteMapData,
  ProjectsV2DeleteMapResponses,
  ProjectsV2DeleteObjectData,
  ProjectsV2DeleteObjectFilesData,
  ProjectsV2DeleteObjectFilesResponses,
  ProjectsV2DeleteObjectResponses,
  ProjectsV2DeletePermitData,
  ProjectsV2DeletePermitResponses,
  ProjectsV2DownloadCsAttachmentsData,
  ProjectsV2DownloadCsAttachmentsResponses,
  ProjectsV2DuplicateMapData,
  ProjectsV2DuplicateMapResponses,
  ProjectsV2EditProjectData,
  ProjectsV2EditProjectGeometryData,
  ProjectsV2EditProjectGeometryResponses,
  ProjectsV2EditProjectResponses,
  ProjectsV2ExportIntelligenceSummariesToExcelData,
  ProjectsV2ExportIntelligenceSummariesToExcelResponses,
  ProjectsV2GenerateEvidenceEmailChainData,
  ProjectsV2GenerateEvidenceEmailChainResponses,
  ProjectsV2GenerateFloodReportData,
  ProjectsV2GenerateFloodReportResponses,
  ProjectsV2GenerateProposalPacketData,
  ProjectsV2GenerateProposalPacketResponses,
  ProjectsV2GenerateRecordsResearchReportData,
  ProjectsV2GenerateRecordsResearchReportResponses,
  ProjectsV2GetAntennaDataData,
  ProjectsV2GetAntennaDataResponses,
  ProjectsV2GetCgsRegulatoryQuadrangleListData,
  ProjectsV2GetCgsRegulatoryQuadrangleListResponses,
  ProjectsV2GetCivilSearchActivitiesData,
  ProjectsV2GetCivilSearchActivitiesResponses,
  ProjectsV2GetCivilSearchMessagesData,
  ProjectsV2GetCivilSearchMessagesResponses,
  ProjectsV2GetDataRequestsV2Data,
  ProjectsV2GetDataRequestsV2Responses,
  ProjectsV2GetDigitizationAccessData,
  ProjectsV2GetDigitizationAccessResponses,
  ProjectsV2GetDownloadRestrictionsData,
  ProjectsV2GetDownloadRestrictionsResponses,
  ProjectsV2GetDownloadSignedUrlData,
  ProjectsV2GetDownloadSignedUrlResponses,
  ProjectsV2GetEnvironmentalStudyDataData,
  ProjectsV2GetEnvironmentalStudyDataResponses,
  ProjectsV2GetEnvironmentalStudyPdfData,
  ProjectsV2GetEnvironmentalStudyPdfResponses,
  ProjectsV2GetEnvironmentalSummaryData,
  ProjectsV2GetEnvironmentalSummaryResponses,
  ProjectsV2GetGeotechnicalSummaryData,
  ProjectsV2GetGeotechnicalSummaryResponses,
  ProjectsV2GetHistoricalUsgsMapsData,
  ProjectsV2GetHistoricalUsgsMapsResponses,
  ProjectsV2GetIntelligenceFeaturesData,
  ProjectsV2GetIntelligenceFeaturesResponses,
  ProjectsV2GetLandRightsSummaryData,
  ProjectsV2GetLandRightsSummaryResponses,
  ProjectsV2GetLatestCivilSearchActivityData,
  ProjectsV2GetLatestCivilSearchActivityResponses,
  ProjectsV2GetLayersData,
  ProjectsV2GetLayersResponses,
  ProjectsV2GetMapData,
  ProjectsV2GetMapResponses,
  ProjectsV2GetParcelDataData,
  ProjectsV2GetParcelDataResponses,
  ProjectsV2GetPermitData,
  ProjectsV2GetPermitResponses,
  ProjectsV2GetProjectAgenciesData,
  ProjectsV2GetProjectAgenciesResponses,
  ProjectsV2GetProjectData,
  ProjectsV2GetProjectDownloadsData,
  ProjectsV2GetProjectDownloadsResponses,
  ProjectsV2GetProjectLayerAssetPresenceData,
  ProjectsV2GetProjectLayerAssetPresenceResponses,
  ProjectsV2GetProjectResponses,
  ProjectsV2GetStoredFileDownloadUrlData,
  ProjectsV2GetStoredFileDownloadUrlResponses,
  ProjectsV2GetUtilitiesFileSignedUrlData,
  ProjectsV2GetUtilitiesFileSignedUrlResponses,
  ProjectsV2GetUtilitiesSummaryData,
  ProjectsV2GetUtilitiesSummaryResponses,
  ProjectsV2GetUtilityAgenciesData,
  ProjectsV2GetUtilityAgenciesResponses,
  ProjectsV2JoinProjectData,
  ProjectsV2JoinProjectResponses,
  ProjectsV2LeaveProjectData,
  ProjectsV2LeaveProjectResponses,
  ProjectsV2ListIntelligenceSummariesData,
  ProjectsV2ListIntelligenceSummariesResponses,
  ProjectsV2ListMapsData,
  ProjectsV2ListMapsResponses,
  ProjectsV2ListProjectsV2Data,
  ProjectsV2ListProjectsV2Responses,
  ProjectsV2ListTransactionsData,
  ProjectsV2ListTransactionsResponses,
  ProjectsV2NewCivilSearchMessageData,
  ProjectsV2NewCivilSearchMessageResponses,
  ProjectsV2PopulateProjectAgenciesDataData,
  ProjectsV2PopulateProjectAgenciesDataResponses,
  ProjectsV2PrintQuoteData,
  ProjectsV2PrintQuoteResponses,
  ProjectsV2PrintReceiptData,
  ProjectsV2PrintReceiptResponses,
  ProjectsV2RemoveMemberData,
  ProjectsV2RemoveMemberResponses,
  ProjectsV2RequestErisDataData,
  ProjectsV2RequestErisDataResponses,
  ProjectsV2SubmitDataRequestsV2Data,
  ProjectsV2SubmitDataRequestsV2Responses,
  ProjectsV2SubmitDownloadRequestData,
  ProjectsV2SubmitDownloadRequestResponses,
  ProjectsV2UndoDeleteObjectData,
  ProjectsV2UndoDeleteObjectResponses,
  ProjectsV2UpdateBillingTierData,
  ProjectsV2UpdateBillingTierResponses,
  ProjectsV2UpdateCommentData,
  ProjectsV2UpdateCommentResponses,
  ProjectsV2UpdateIntelligenceStatusData,
  ProjectsV2UpdateIntelligenceStatusResponses,
  ProjectsV2UpdateIntelligenceSummaryData,
  ProjectsV2UpdateIntelligenceSummaryResponses,
  ProjectsV2UpdateMapData,
  ProjectsV2UpdateMapResponses,
  ProjectsV2UpdateObjectData,
  ProjectsV2UpdateObjectResponses,
  ProjectsV2UpdateUtilityNoteData,
  ProjectsV2UpdateUtilityNoteResponses,
  ProjectsV2UpsertPermitData,
  ProjectsV2UpsertPermitResponses,
  ProjectsV3AddShapefileCustomDataData,
  ProjectsV3AddShapefileCustomDataResponses,
  ProjectsV3AddWmtsCustomDataData,
  ProjectsV3AddWmtsCustomDataResponses,
  ProjectsV3BulkAddProjectBookmarksData,
  ProjectsV3BulkAddProjectBookmarksResponses,
  ProjectsV3BulkInviteMembersData,
  ProjectsV3BulkInviteMembersResponses,
  ProjectsV3BulkUpdateConstructionDatesData,
  ProjectsV3BulkUpdateConstructionDatesResponses,
  ProjectsV3BulkUpdatePlanStatusData,
  ProjectsV3BulkUpdatePlanStatusResponses,
  ProjectsV3BulkUpdateProjectsData,
  ProjectsV3BulkUpdateProjectsResponses,
  ProjectsV3DeleteCustomDataData,
  ProjectsV3DeleteCustomDataResponses,
  ProjectsV3DownloadCustomDataSourceData,
  ProjectsV3DownloadCustomDataSourceResponses,
  ProjectsV3ExportIntelligenceSummariesToExcelData,
  ProjectsV3ExportIntelligenceSummariesToExcelResponses,
  ProjectsV3ExportProjectsToExcelData,
  ProjectsV3ExportProjectsToExcelResponses,
  ProjectsV3GetIntelligenceSummaryMetaData,
  ProjectsV3GetIntelligenceSummaryMetaResponses,
  ProjectsV3GetProjectIntelligenceData,
  ProjectsV3GetProjectIntelligenceResponses,
  ProjectsV3GetSandboxProjectData,
  ProjectsV3GetSandboxProjectResponses,
  ProjectsV3InspectWmtsCustomDataData,
  ProjectsV3InspectWmtsCustomDataResponses,
  ProjectsV3InviteMembersData,
  ProjectsV3InviteMembersResponses,
  ProjectsV3ListAllProjectsData,
  ProjectsV3ListAllProjectsResponses,
  ProjectsV3ListCustomDataData,
  ProjectsV3ListCustomDataResponses,
  ProjectsV3ListGeoRefMapsForProjectData,
  ProjectsV3ListGeoRefMapsForProjectResponses,
  ProjectsV3ListIntelligenceSummariesData,
  ProjectsV3ListIntelligenceSummariesResponses,
  ProjectsV3ListProjectAgencyHistoryData,
  ProjectsV3ListProjectAgencyHistoryResponses,
  ProjectsV3ListProjectConnectbaseTasksData,
  ProjectsV3ListProjectConnectbaseTasksResponses,
  ProjectsV3ListProjectsData,
  ProjectsV3ListProjectsResponses,
  ProjectsV3SetCustomDataCategoriesData,
  ProjectsV3SetCustomDataCategoriesResponses,
  ProjectsV3SetCustomDataLabelData,
  ProjectsV3SetCustomDataLabelResponses,
  ProjectsV3SetCustomDataVisibilityData,
  ProjectsV3SetCustomDataVisibilityResponses,
  ProjectsV3ToggleProjectBookmarkData,
  ProjectsV3ToggleProjectBookmarkResponses,
  ReportProblemCreateData,
  ReportProblemCreateResponses,
  TileLayersListData,
  TileLayersListResponses,
  TitleGetDocumentByIdData,
  TitleGetDocumentByIdDownloadData,
  TitleGetDocumentByIdDownloadResponses,
  TitleGetDocumentByIdResponses,
  TitleGetDocumentsByIdsData,
  TitleGetDocumentsByIdsDownloadData,
  TitleGetDocumentsByIdsDownloadResponses,
  TitleGetDocumentsByIdsResponses,
  TitleGetParcelDetailsData,
  TitleGetParcelDetailsResponses,
  TitleGetReportDocsData,
  TitleGetReportDocsDownloadData,
  TitleGetReportDocsDownloadResponses,
  TitleGetReportDocsResponses,
  TitleGetTitleReportData,
  TitleGetTitleReportResponses,
  TitleOrderPrelimTitleReportData,
  TitleOrderPrelimTitleReportResponses,
  UploadsV3GetUploadData,
  UploadsV3GetUploadResponses,
  UploadsV3PresignUploadData,
  UploadsV3PresignUploadResponses,
  UploadsV3RegisterUploadData,
  UploadsV3RegisterUploadResponses,
  UserLayerConfigGetData,
  UserLayerConfigGetResponses,
  UserLayerConfigSeedData,
  UserLayerConfigSeedResponses,
  UserLayerConfigUpdateData,
  UserLayerConfigUpdateResponses,
  UsersCheckIfDomainAllowedData,
  UsersCheckIfDomainAllowedResponses,
  UsersCreateOrganizationData,
  UsersCreateOrganizationResponses,
  UsersFailedVerificationData,
  UsersFailedVerificationResponses,
  UsersGetMeData,
  UsersGetMeResponses,
  UsersSkipVerificationData,
  UsersSkipVerificationResponses,
  UsersUpdateProfileData,
  UsersUpdateProfileResponses,
  UsersUpdateProjectBookmarksData,
  UsersUpdateProjectBookmarksResponses,
  UsersUserCompletedVerificationData,
  UsersUserCompletedVerificationResponses,
  VerificationHandleWebhookData,
  VerificationHandleWebhookResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const healthTick = <ThrowOnError extends boolean = true>(
  options?: Options<HealthTickData, ThrowOnError>,
): RequestResult<HealthTickResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<HealthTickResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tick/',
    ...options,
  });

export const authValidateToken = <ThrowOnError extends boolean = true>(
  options?: Options<AuthValidateTokenData, ThrowOnError>,
): RequestResult<AuthValidateTokenResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<AuthValidateTokenResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/auth/validateToken',
    ...options,
  });

export const availableLayersList = <ThrowOnError extends boolean = true>(
  options: Options<AvailableLayersListData, ThrowOnError>,
): RequestResult<AvailableLayersListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<AvailableLayersListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/availableLayers/',
    ...options,
  });

export const dataRefreshStatusList = <ThrowOnError extends boolean = true>(
  options: Options<DataRefreshStatusListData, ThrowOnError>,
): RequestResult<DataRefreshStatusListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DataRefreshStatusListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/dataRefreshStatus/',
    ...options,
  });

export const drfSubmitRequest = <ThrowOnError extends boolean = true>(
  options?: Options<DrfSubmitRequestData, ThrowOnError>,
): RequestResult<DrfSubmitRequestResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<DrfSubmitRequestResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/submitRequest',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const drfUploadCeiiFile = <ThrowOnError extends boolean = true>(
  options: Options<DrfUploadCeiiFileData, ThrowOnError>,
): RequestResult<DrfUploadCeiiFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DrfUploadCeiiFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/{requestId}/ceiiFile',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const drfListDrfRequests = <ThrowOnError extends boolean = true>(
  options: Options<DrfListDrfRequestsData, ThrowOnError>,
): RequestResult<DrfListDrfRequestsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DrfListDrfRequestsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/',
    ...options,
  });

export const drfUpdateDrfRequest = <ThrowOnError extends boolean = true>(
  options: Options<DrfUpdateDrfRequestData, ThrowOnError>,
): RequestResult<DrfUpdateDrfRequestResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<DrfUpdateDrfRequestResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/{requestId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const drfRegenerateApprovalPacket = <ThrowOnError extends boolean = true>(
  options: Options<DrfRegenerateApprovalPacketData, ThrowOnError>,
): RequestResult<DrfRegenerateApprovalPacketResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DrfRegenerateApprovalPacketResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/{requestId}/regenerateApprovalPacket',
    ...options,
  });

export const drfCreatePaymentIntent = <ThrowOnError extends boolean = true>(
  options?: Options<DrfCreatePaymentIntentData, ThrowOnError>,
): RequestResult<DrfCreatePaymentIntentResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<DrfCreatePaymentIntentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/createPaymentIntent',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const drfValidateGoogleRecaptcha = <ThrowOnError extends boolean = true>(
  options?: Options<DrfValidateGoogleRecaptchaData, ThrowOnError>,
): RequestResult<DrfValidateGoogleRecaptchaResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<DrfValidateGoogleRecaptchaResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/validateGoogleRecaptcha',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const drfExportDrfTableToExcel = <ThrowOnError extends boolean = true>(
  options?: Options<DrfExportDrfTableToExcelData, ThrowOnError>,
): RequestResult<DrfExportDrfTableToExcelResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<DrfExportDrfTableToExcelResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/exportDrfTableToExcel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const drfGetDrfRequestActivities = <ThrowOnError extends boolean = true>(
  options: Options<DrfGetDrfRequestActivitiesData, ThrowOnError>,
): RequestResult<DrfGetDrfRequestActivitiesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DrfGetDrfRequestActivitiesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/drf/drfRequestActivities/{requestId}',
    ...options,
  });

export const extractGetFiberRoutes = <ThrowOnError extends boolean = true>(
  options?: Options<ExtractGetFiberRoutesData, ThrowOnError>,
): RequestResult<ExtractGetFiberRoutesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ExtractGetFiberRoutesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/v1/extract/connectbase/routes',
    ...options,
  });

export const extractGetFiberLitBuildings = <ThrowOnError extends boolean = true>(
  options?: Options<ExtractGetFiberLitBuildingsData, ThrowOnError>,
): RequestResult<ExtractGetFiberLitBuildingsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ExtractGetFiberLitBuildingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/v1/extract/connectbase/lit-buildings',
    ...options,
  });

export const extractGetExtractProjections = <ThrowOnError extends boolean = true>(
  options: Options<ExtractGetExtractProjectionsData, ThrowOnError>,
): RequestResult<ExtractGetExtractProjectionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ExtractGetExtractProjectionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/extract/projections',
    ...options,
  });

export const extractGetDefaultExtractProjection = <ThrowOnError extends boolean = true>(
  options: Options<ExtractGetDefaultExtractProjectionData, ThrowOnError>,
): RequestResult<ExtractGetDefaultExtractProjectionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ExtractGetDefaultExtractProjectionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/extract/projections/default',
    ...options,
  });

export const extractNotifyExtractResult = <ThrowOnError extends boolean = true>(
  options?: Options<ExtractNotifyExtractResultData, ThrowOnError>,
): RequestResult<ExtractNotifyExtractResultResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ExtractNotifyExtractResultResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/extract/notifyExtractResult',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const extractGetExtractResources = <ThrowOnError extends boolean = true>(
  options?: Options<ExtractGetExtractResourcesData, ThrowOnError>,
): RequestResult<ExtractGetExtractResourcesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<ExtractGetExtractResourcesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/extract/resources',
    ...options,
  });

export const extractProjectExtract = <ThrowOnError extends boolean = true>(
  options?: Options<ExtractProjectExtractData, ThrowOnError>,
): RequestResult<ExtractProjectExtractResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ExtractProjectExtractResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/extract/projectExtract',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const extractGetOrganizationExtractTemplates = <ThrowOnError extends boolean = true>(
  options: Options<ExtractGetOrganizationExtractTemplatesData, ThrowOnError>,
): RequestResult<ExtractGetOrganizationExtractTemplatesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ExtractGetOrganizationExtractTemplatesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/extract/organizationExtractTemplates',
    ...options,
  });

export const internalGetAllOrganizations = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetAllOrganizationsData, ThrowOnError>,
): RequestResult<InternalGetAllOrganizationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetAllOrganizationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/getAllOrganizations',
    ...options,
  });

export const internalGetSpecialDatasetSlugs = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetSpecialDatasetSlugsData, ThrowOnError>,
): RequestResult<InternalGetSpecialDatasetSlugsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetSpecialDatasetSlugsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/specialDatasetSlugs',
    ...options,
  });

export const internalCreateOrganization = <ThrowOnError extends boolean = true>(
  options?: Options<InternalCreateOrganizationData, ThrowOnError>,
): RequestResult<InternalCreateOrganizationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalCreateOrganizationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/createOrganization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalCreateSandboxOrg = <ThrowOnError extends boolean = true>(
  options?: Options<InternalCreateSandboxOrgData, ThrowOnError>,
): RequestResult<InternalCreateSandboxOrgResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalCreateSandboxOrgResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/createSandboxOrg',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalAddTransaction = <ThrowOnError extends boolean = true>(
  options?: Options<InternalAddTransactionData, ThrowOnError>,
): RequestResult<InternalAddTransactionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalAddTransactionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/addTransaction',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalGetAllUsers = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetAllUsersData, ThrowOnError>,
): RequestResult<InternalGetAllUsersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetAllUsersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/getAllUsers',
    ...options,
  });

export const internalGetInternalAdminUsers = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetInternalAdminUsersData, ThrowOnError>,
): RequestResult<InternalGetInternalAdminUsersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetInternalAdminUsersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/getInternalUsers',
    ...options,
  });

export const internalSetUserToOnboarded = <ThrowOnError extends boolean = true>(
  options: Options<InternalSetUserToOnboardedData, ThrowOnError>,
): RequestResult<InternalSetUserToOnboardedResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalSetUserToOnboardedResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/setUserToOnboarded',
    ...options,
  });

export const internalUpdateTelcoAccess = <ThrowOnError extends boolean = true>(
  options: Options<InternalUpdateTelcoAccessData, ThrowOnError>,
): RequestResult<InternalUpdateTelcoAccessResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalUpdateTelcoAccessResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/updateTelcoAccess',
    ...options,
  });

export const internalUpdateOrgPlan = <ThrowOnError extends boolean = true>(
  options: Options<InternalUpdateOrgPlanData, ThrowOnError>,
): RequestResult<InternalUpdateOrgPlanResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalUpdateOrgPlanResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/updateOrgPlan',
    ...options,
  });

export const internalSetUserToApproved = <ThrowOnError extends boolean = true>(
  options: Options<InternalSetUserToApprovedData, ThrowOnError>,
): RequestResult<InternalSetUserToApprovedResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalSetUserToApprovedResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/setUserToApproved',
    ...options,
  });

export const internalPrintOrgInvoice = <ThrowOnError extends boolean = true>(
  options?: Options<InternalPrintOrgInvoiceData, ThrowOnError>,
): RequestResult<InternalPrintOrgInvoiceResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalPrintOrgInvoiceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/printOrgInvoice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalToggleIsBillable = <ThrowOnError extends boolean = true>(
  options: Options<InternalToggleIsBillableData, ThrowOnError>,
): RequestResult<InternalToggleIsBillableResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalToggleIsBillableResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/toggleIsBillable',
    ...options,
  });

export const internalRunAgencyLoader = <ThrowOnError extends boolean = true>(
  options?: Options<InternalRunAgencyLoaderData, ThrowOnError>,
): RequestResult<InternalRunAgencyLoaderResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalRunAgencyLoaderResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/runAgencyLoader',
    ...options,
  });

export const internalClearEsriCache = <ThrowOnError extends boolean = true>(
  options?: Options<InternalClearEsriCacheData, ThrowOnError>,
): RequestResult<InternalClearEsriCacheResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalClearEsriCacheResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/clearEsriCache',
    ...options,
  });

export const internalRefreshTiles = <ThrowOnError extends boolean = true>(
  options?: Options<InternalRefreshTilesData, ThrowOnError>,
): RequestResult<InternalRefreshTilesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalRefreshTilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/refreshTiles',
    ...options,
  });

export const internalListOrgProjectsAsAdm = <ThrowOnError extends boolean = true>(
  options: Options<InternalListOrgProjectsAsAdmData, ThrowOnError>,
): RequestResult<InternalListOrgProjectsAsAdmResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalListOrgProjectsAsAdmResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/listOrgProjectsAsAdm',
    ...options,
  });

export const internalComputeIntelligence = <ThrowOnError extends boolean = true>(
  options: Options<InternalComputeIntelligenceData, ThrowOnError>,
): RequestResult<InternalComputeIntelligenceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InternalComputeIntelligenceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/computeIntelligence',
    ...options,
  });

export const internalSyncIntelligence = <ThrowOnError extends boolean = true>(
  options?: Options<InternalSyncIntelligenceData, ThrowOnError>,
): RequestResult<InternalSyncIntelligenceResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalSyncIntelligenceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/syncIntelligence',
    ...options,
  });

export const internalGetOrganizationSubscriptions = <ThrowOnError extends boolean = true>(
  options: Options<InternalGetOrganizationSubscriptionsData, ThrowOnError>,
): RequestResult<InternalGetOrganizationSubscriptionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalGetOrganizationSubscriptionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/organizations/{organizationId}/subscriptions',
    ...options,
  });

export const internalGetOrganization = <ThrowOnError extends boolean = true>(
  options: Options<InternalGetOrganizationData, ThrowOnError>,
): RequestResult<InternalGetOrganizationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalGetOrganizationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/organizations/{organizationId}',
    ...options,
  });

export const internalUpdateOrgSpecialDatasets = <ThrowOnError extends boolean = true>(
  options: Options<InternalUpdateOrgSpecialDatasetsData, ThrowOnError>,
): RequestResult<InternalUpdateOrgSpecialDatasetsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<InternalUpdateOrgSpecialDatasetsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/organizations/{organizationId}/specialDatasets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const internalUpdateOrgConnectbaseLookup = <ThrowOnError extends boolean = true>(
  options: Options<InternalUpdateOrgConnectbaseLookupData, ThrowOnError>,
): RequestResult<InternalUpdateOrgConnectbaseLookupResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<InternalUpdateOrgConnectbaseLookupResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/organizations/{organizationId}/connectbaseLookup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const internalGetAdminTileLayers = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetAdminTileLayersData, ThrowOnError>,
): RequestResult<InternalGetAdminTileLayersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetAdminTileLayersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/tileLayers',
    ...options,
  });

export const internalUpdateDisabledTileLayers = <ThrowOnError extends boolean = true>(
  options?: Options<InternalUpdateDisabledTileLayersData, ThrowOnError>,
): RequestResult<InternalUpdateDisabledTileLayersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).put<InternalUpdateDisabledTileLayersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/tileLayers/disabled',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalLoadStagingLayerCatalog = <ThrowOnError extends boolean = true>(
  options?: Options<InternalLoadStagingLayerCatalogData, ThrowOnError>,
): RequestResult<InternalLoadStagingLayerCatalogResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalLoadStagingLayerCatalogResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/loadStagingLayerCatalog',
    ...options,
  });

export const internalJoinOrgAsAdmin = <ThrowOnError extends boolean = true>(
  options: Options<InternalJoinOrgAsAdminData, ThrowOnError>,
): RequestResult<InternalJoinOrgAsAdminResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InternalJoinOrgAsAdminResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/joinOrgAsAdmin',
    ...options,
  });

export const internalTriggerDigestForProject = <ThrowOnError extends boolean = true>(
  options: Options<InternalTriggerDigestForProjectData, ThrowOnError>,
): RequestResult<InternalTriggerDigestForProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InternalTriggerDigestForProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/triggerDigestForProject',
    ...options,
  });

export const internalUpdateOrganizationSubscription = <ThrowOnError extends boolean = true>(
  options?: Options<InternalUpdateOrganizationSubscriptionData, ThrowOnError>,
): RequestResult<InternalUpdateOrganizationSubscriptionResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalUpdateOrganizationSubscriptionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/updateOrganizationSubscription',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalUpdateLinkedOrganizations = <ThrowOnError extends boolean = true>(
  options?: Options<InternalUpdateLinkedOrganizationsData, ThrowOnError>,
): RequestResult<InternalUpdateLinkedOrganizationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalUpdateLinkedOrganizationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/updateLinkedOrganizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalPromoteGisConfig = <ThrowOnError extends boolean = true>(
  options?: Options<InternalPromoteGisConfigData, ThrowOnError>,
): RequestResult<InternalPromoteGisConfigResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalPromoteGisConfigResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/promoteGisConfig',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalRefreshTileConfig = <ThrowOnError extends boolean = true>(
  options?: Options<InternalRefreshTileConfigData, ThrowOnError>,
): RequestResult<InternalRefreshTileConfigResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalRefreshTileConfigResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/refreshTileConfig',
    ...options,
  });

export const internalGetPgeCloudSyncFolders = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetPgeCloudSyncFoldersData, ThrowOnError>,
): RequestResult<InternalGetPgeCloudSyncFoldersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetPgeCloudSyncFoldersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/pgeCloudSync/folders',
    ...options,
  });

export const internalTriggerPgeCloudSyncWorkflow = <ThrowOnError extends boolean = true>(
  options?: Options<InternalTriggerPgeCloudSyncWorkflowData, ThrowOnError>,
): RequestResult<InternalTriggerPgeCloudSyncWorkflowResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalTriggerPgeCloudSyncWorkflowResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/pgeCloudSync/trigger',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalGetSubscriptionsStatus = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetSubscriptionsStatusData, ThrowOnError>,
): RequestResult<InternalGetSubscriptionsStatusResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetSubscriptionsStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/subscriptions/status',
    ...options,
  });

export const internalUpdateSubscriptionContractEndsOn = <ThrowOnError extends boolean = true>(
  options: Options<InternalUpdateSubscriptionContractEndsOnData, ThrowOnError>,
): RequestResult<InternalUpdateSubscriptionContractEndsOnResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<InternalUpdateSubscriptionContractEndsOnResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/subscriptions/{organizationId}/contractEndsOn',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const internalUpdateOrganizationAccountType = <ThrowOnError extends boolean = true>(
  options: Options<InternalUpdateOrganizationAccountTypeData, ThrowOnError>,
): RequestResult<InternalUpdateOrganizationAccountTypeResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<InternalUpdateOrganizationAccountTypeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/organizations/{organizationId}/accountType',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const internalGetDemoOrgs = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetDemoOrgsData, ThrowOnError>,
): RequestResult<InternalGetDemoOrgsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetDemoOrgsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/getDemoOrgs',
    ...options,
  });

export const internalResetDemoOrg = <ThrowOnError extends boolean = true>(
  options?: Options<InternalResetDemoOrgData, ThrowOnError>,
): RequestResult<InternalResetDemoOrgResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalResetDemoOrgResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/resetDemoOrg',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalSyncExtractProjections = <ThrowOnError extends boolean = true>(
  options?: Options<InternalSyncExtractProjectionsData, ThrowOnError>,
): RequestResult<InternalSyncExtractProjectionsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalSyncExtractProjectionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/extract/syncProjections',
    ...options,
  });

export const internalCreateExtractAutomation = <ThrowOnError extends boolean = true>(
  options?: Options<InternalCreateExtractAutomationData, ThrowOnError>,
): RequestResult<InternalCreateExtractAutomationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalCreateExtractAutomationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/extract/automations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalActivateExtractAutomation = <ThrowOnError extends boolean = true>(
  options: Options<InternalActivateExtractAutomationData, ThrowOnError>,
): RequestResult<InternalActivateExtractAutomationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InternalActivateExtractAutomationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/extract/automations/{id}/activate',
    ...options,
  });

export const internalDeleteExtractAutomation = <ThrowOnError extends boolean = true>(
  options: Options<InternalDeleteExtractAutomationData, ThrowOnError>,
): RequestResult<InternalDeleteExtractAutomationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<InternalDeleteExtractAutomationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/extract/automations/{id}',
    ...options,
  });

export const internalCreateExtractTemplate = <ThrowOnError extends boolean = true>(
  options?: Options<InternalCreateExtractTemplateData, ThrowOnError>,
): RequestResult<InternalCreateExtractTemplateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalCreateExtractTemplateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/extract/templates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalAssignExtractTemplate = <ThrowOnError extends boolean = true>(
  options?: Options<InternalAssignExtractTemplateData, ThrowOnError>,
): RequestResult<InternalAssignExtractTemplateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<InternalAssignExtractTemplateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/extract/templates/assign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const internalGetExtractAdminState = <ThrowOnError extends boolean = true>(
  options?: Options<InternalGetExtractAdminStateData, ThrowOnError>,
): RequestResult<InternalGetExtractAdminStateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalGetExtractAdminStateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/extract/state',
    ...options,
  });

export const internalListExportEscalations = <ThrowOnError extends boolean = true>(
  options?: Options<InternalListExportEscalationsData, ThrowOnError>,
): RequestResult<InternalListExportEscalationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<InternalListExportEscalationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/export-escalations',
    ...options,
  });

export const internalGetExportEscalation = <ThrowOnError extends boolean = true>(
  options: Options<InternalGetExportEscalationData, ThrowOnError>,
): RequestResult<InternalGetExportEscalationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<InternalGetExportEscalationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/export-escalations/{id}',
    ...options,
  });

export const internalUpdateExportEscalationNotes = <ThrowOnError extends boolean = true>(
  options: Options<InternalUpdateExportEscalationNotesData, ThrowOnError>,
): RequestResult<InternalUpdateExportEscalationNotesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<InternalUpdateExportEscalationNotesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/export-escalations/{id}/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const internalArchiveExportEscalation = <ThrowOnError extends boolean = true>(
  options: Options<InternalArchiveExportEscalationData, ThrowOnError>,
): RequestResult<InternalArchiveExportEscalationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InternalArchiveExportEscalationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/export-escalations/{id}/archive',
    ...options,
  });

export const internalRunExportEscalation = <ThrowOnError extends boolean = true>(
  options: Options<InternalRunExportEscalationData, ThrowOnError>,
): RequestResult<InternalRunExportEscalationResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InternalRunExportEscalationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/export-escalations/{id}/run',
    ...options,
  });

export const internalRestoreGeoItemRevision = <ThrowOnError extends boolean = true>(
  options: Options<InternalRestoreGeoItemRevisionData, ThrowOnError>,
): RequestResult<InternalRestoreGeoItemRevisionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<InternalRestoreGeoItemRevisionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/internal/geoItemRevisions/{revisionId}/restore',
    ...options,
  });

export const userLayerConfigSeed = <ThrowOnError extends boolean = true>(
  options: Options<UserLayerConfigSeedData, ThrowOnError>,
): RequestResult<UserLayerConfigSeedResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UserLayerConfigSeedResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/layerConfig/seed',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const userLayerConfigGet = <ThrowOnError extends boolean = true>(
  options: Options<UserLayerConfigGetData, ThrowOnError>,
): RequestResult<UserLayerConfigGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UserLayerConfigGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/layerConfig/',
    ...options,
  });

export const userLayerConfigUpdate = <ThrowOnError extends boolean = true>(
  options: Options<UserLayerConfigUpdateData, ThrowOnError>,
): RequestResult<UserLayerConfigUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<UserLayerConfigUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/layerConfig/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const miscGet811Data = <ThrowOnError extends boolean = true>(
  options?: Options<MiscGet811DataData, ThrowOnError>,
): RequestResult<MiscGet811DataResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<MiscGet811DataResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/misc/get811Data',
    ...options,
  });

export const miscLogEvent = <ThrowOnError extends boolean = true>(
  options?: Options<MiscLogEventData, ThrowOnError>,
): RequestResult<MiscLogEventResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<MiscLogEventResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/misc/logEvent',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const miscCalculateWatershedRisk = <ThrowOnError extends boolean = true>(
  options: Options<MiscCalculateWatershedRiskData, ThrowOnError>,
): RequestResult<MiscCalculateWatershedRiskResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<MiscCalculateWatershedRiskResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/misc/calculateWatershedRisk',
    ...options,
  });

export const mobileVersionGet = <ThrowOnError extends boolean = true>(
  options?: Options<MobileVersionGetData, ThrowOnError>,
): RequestResult<MobileVersionGetResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<MobileVersionGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/mobile/version-check',
    ...options,
  });

export const mobileVersionUpdate = <ThrowOnError extends boolean = true>(
  options?: Options<MobileVersionUpdateData, ThrowOnError>,
): RequestResult<MobileVersionUpdateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).put<MobileVersionUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/mobile/version-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const organizationsGetMyOrganizations = <ThrowOnError extends boolean = true>(
  options?: Options<OrganizationsGetMyOrganizationsData, ThrowOnError>,
): RequestResult<OrganizationsGetMyOrganizationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<OrganizationsGetMyOrganizationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/mine',
    ...options,
  });

export const organizationsGet = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsGetData, ThrowOnError>,
): RequestResult<OrganizationsGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationsGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}',
    ...options,
  });

export const organizationsEdit = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsEditData, ThrowOnError>,
): RequestResult<OrganizationsEditResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<OrganizationsEditResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const organizationsGetMembers = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsGetMembersData, ThrowOnError>,
): RequestResult<OrganizationsGetMembersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationsGetMembersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/members',
    ...options,
  });

export const organizationsAddMembers = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsAddMembersData, ThrowOnError>,
): RequestResult<OrganizationsAddMembersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrganizationsAddMembersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/members',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const organizationsEditMember = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsEditMemberData, ThrowOnError>,
): RequestResult<OrganizationsEditMemberResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<OrganizationsEditMemberResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/members/{memberId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const organizationsEditRole = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsEditRoleData, ThrowOnError>,
): RequestResult<OrganizationsEditRoleResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<OrganizationsEditRoleResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/roles/{roleId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const organizationsResendInvite = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsResendInviteData, ThrowOnError>,
): RequestResult<OrganizationsResendInviteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationsResendInviteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/members/{memberId}/resendInvite',
    ...options,
  });

export const organizationsAddFile = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsAddFileData, ThrowOnError>,
): RequestResult<OrganizationsAddFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrganizationsAddFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const organizationsGetOrgSummary = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsGetOrgSummaryData, ThrowOnError>,
): RequestResult<OrganizationsGetOrgSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationsGetOrgSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/orgSummary',
    ...options,
  });

export const organizationsGetBillingSummary = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsGetBillingSummaryData, ThrowOnError>,
): RequestResult<OrganizationsGetBillingSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrganizationsGetBillingSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/billingSummary',
    ...options,
  });

export const organizationsPrintBillingSummary = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsPrintBillingSummaryData, ThrowOnError>,
): RequestResult<OrganizationsPrintBillingSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrganizationsPrintBillingSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/printBillingSummary',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const organizationsSetTestEnvOverride = <ThrowOnError extends boolean = true>(
  options: Options<OrganizationsSetTestEnvOverrideData, ThrowOnError>,
): RequestResult<OrganizationsSetTestEnvOverrideResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<OrganizationsSetTestEnvOverrideResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/organizations/{organizationId}/useTestEnv',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const orgLayerConfigGet = <ThrowOnError extends boolean = true>(
  options: Options<OrgLayerConfigGetData, ThrowOnError>,
): RequestResult<OrgLayerConfigGetResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<OrgLayerConfigGetResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/orgLayerConfig/',
    ...options,
  });

export const orgLayerConfigUpdate = <ThrowOnError extends boolean = true>(
  options: Options<OrgLayerConfigUpdateData, ThrowOnError>,
): RequestResult<OrgLayerConfigUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<OrgLayerConfigUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/orgLayerConfig/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const preferencesUpdateProjectMemberNotifications = <ThrowOnError extends boolean = true>(
  options: Options<PreferencesUpdateProjectMemberNotificationsData, ThrowOnError>,
): RequestResult<PreferencesUpdateProjectMemberNotificationsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<PreferencesUpdateProjectMemberNotificationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/preferences/projects/{projectId}/members/notifications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsAddFile = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsAddFileData, ThrowOnError>,
): RequestResult<ProjectsAddFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsAddFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const projectsDeleteFile = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsDeleteFileData, ThrowOnError>,
): RequestResult<ProjectsDeleteFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsDeleteFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/files/{fileId}',
    ...options,
  });

export const projectsUpdateFile = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsUpdateFileData, ThrowOnError>,
): RequestResult<ProjectsUpdateFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsUpdateFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/files/{fileId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsAddParcelDetails = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsAddParcelDetailsData, ThrowOnError>,
): RequestResult<ProjectsAddParcelDetailsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsAddParcelDetailsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/parcelDetails',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsRequestData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsRequestDataData, ThrowOnError>,
): RequestResult<ProjectsRequestDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsRequestDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/requestData',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsFetchGeotech = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsFetchGeotechData, ThrowOnError>,
): RequestResult<ProjectsFetchGeotechResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsFetchGeotechResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/fetchGeotech',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsCheckForSoilsRequest = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsCheckForSoilsRequestData, ThrowOnError>,
): RequestResult<ProjectsCheckForSoilsRequestResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsCheckForSoilsRequestResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/checkForSoilsRequest',
    ...options,
  });

export const projectsSoilsRequest = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsSoilsRequestData, ThrowOnError>,
): RequestResult<ProjectsSoilsRequestResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsSoilsRequestResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/soilsRequest',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsListGeoItems = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsListGeoItemsData, ThrowOnError>,
): RequestResult<ProjectsListGeoItemsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsListGeoItemsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/geoItems',
    ...options,
  });

export const projectsCreateGeoItem = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsCreateGeoItemData, ThrowOnError>,
): RequestResult<ProjectsCreateGeoItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsCreateGeoItemResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/geoItems',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsDeleteGeoItem = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsDeleteGeoItemData, ThrowOnError>,
): RequestResult<ProjectsDeleteGeoItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsDeleteGeoItemResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/geoItems/{geoItemId}',
    ...options,
  });

export const projectsEditGeoItem = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsEditGeoItemData, ThrowOnError>,
): RequestResult<ProjectsEditGeoItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsEditGeoItemResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/geoItems/{geoItemId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsPrintGeoItem = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsPrintGeoItemData, ThrowOnError>,
): RequestResult<ProjectsPrintGeoItemResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsPrintGeoItemResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/geoItems/{reportType}/print',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsPrintProjectPdf = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsPrintProjectPdfData, ThrowOnError>,
): RequestResult<ProjectsPrintProjectPdfResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsPrintProjectPdfResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/print',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsGetZoningData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetZoningDataData, ThrowOnError>,
): RequestResult<ProjectsGetZoningDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsGetZoningDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/getZoningData',
    ...options,
  });

export const projectsParcelPointQuery = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsParcelPointQueryData, ThrowOnError>,
): RequestResult<ProjectsParcelPointQueryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsParcelPointQueryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/parcelPointQuery',
    ...options,
  });

export const projectsGetStatePlaneZone = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetStatePlaneZoneData, ThrowOnError>,
): RequestResult<ProjectsGetStatePlaneZoneResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsGetStatePlaneZoneResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/getStatePlaneZone',
    ...options,
  });

export const projectsGetProjectFeatures = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectFeaturesData, ThrowOnError>,
): RequestResult<ProjectsGetProjectFeaturesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsGetProjectFeaturesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/projects/{projectId}/getProjectFeatures',
    ...options,
  });

export const reportProblemCreate = <ThrowOnError extends boolean = true>(
  options?: Options<ReportProblemCreateData, ThrowOnError>,
): RequestResult<ReportProblemCreateResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ReportProblemCreateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/reportProblem/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const tileLayersList = <ThrowOnError extends boolean = true>(
  options?: Options<TileLayersListData, ThrowOnError>,
): RequestResult<TileLayersListResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<TileLayersListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/tileLayers/',
    ...options,
  });

export const titleGetTitleReport = <ThrowOnError extends boolean = true>(
  options?: Options<TitleGetTitleReportData, ThrowOnError>,
): RequestResult<TitleGetTitleReportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<TitleGetTitleReportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/getTitleReport',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const titleGetReportDocs = <ThrowOnError extends boolean = true>(
  options: Options<TitleGetReportDocsData, ThrowOnError>,
): RequestResult<TitleGetReportDocsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<TitleGetReportDocsResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/getReportDocs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const titleGetReportDocsDownload = <ThrowOnError extends boolean = true>(
  options: Options<TitleGetReportDocsDownloadData, ThrowOnError>,
): RequestResult<TitleGetReportDocsDownloadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<TitleGetReportDocsDownloadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/getReportDocsDownload',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const titleGetParcelDetails = <ThrowOnError extends boolean = true>(
  options: Options<TitleGetParcelDetailsData, ThrowOnError>,
): RequestResult<TitleGetParcelDetailsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<TitleGetParcelDetailsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/getParcelDetails',
    ...options,
  });

export const titleGetDocumentById = <ThrowOnError extends boolean = true>(
  options: Options<TitleGetDocumentByIdData, ThrowOnError>,
): RequestResult<TitleGetDocumentByIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<TitleGetDocumentByIdResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/getDocumentById',
    ...options,
  });

export const titleGetDocumentByIdDownload = <ThrowOnError extends boolean = true>(
  options: Options<TitleGetDocumentByIdDownloadData, ThrowOnError>,
): RequestResult<TitleGetDocumentByIdDownloadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<TitleGetDocumentByIdDownloadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/getDocumentByIdDownload',
    ...options,
  });

export const titleOrderPrelimTitleReport = <ThrowOnError extends boolean = true>(
  options?: Options<TitleOrderPrelimTitleReportData, ThrowOnError>,
): RequestResult<TitleOrderPrelimTitleReportResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<TitleOrderPrelimTitleReportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/orderPrelimTitleReport',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const titleGetDocumentsByIds = <ThrowOnError extends boolean = true>(
  options?: Options<TitleGetDocumentsByIdsData, ThrowOnError>,
): RequestResult<TitleGetDocumentsByIdsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<TitleGetDocumentsByIdsResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/getDocumentsByIds',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const titleGetDocumentsByIdsDownload = <ThrowOnError extends boolean = true>(
  options?: Options<TitleGetDocumentsByIdsDownloadData, ThrowOnError>,
): RequestResult<TitleGetDocumentsByIdsDownloadResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<TitleGetDocumentsByIdsDownloadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/title/getDocumentsByIdsDownload',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const usersUserCompletedVerification = <ThrowOnError extends boolean = true>(
  options?: Options<UsersUserCompletedVerificationData, ThrowOnError>,
): RequestResult<UsersUserCompletedVerificationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersUserCompletedVerificationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/userCompletedVerification',
    ...options,
  });

export const usersFailedVerification = <ThrowOnError extends boolean = true>(
  options?: Options<UsersFailedVerificationData, ThrowOnError>,
): RequestResult<UsersFailedVerificationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersFailedVerificationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/failedVerification',
    ...options,
  });

export const usersSkipVerification = <ThrowOnError extends boolean = true>(
  options?: Options<UsersSkipVerificationData, ThrowOnError>,
): RequestResult<UsersSkipVerificationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersSkipVerificationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/skipVerification',
    ...options,
  });

export const usersGetMe = <ThrowOnError extends boolean = true>(
  options?: Options<UsersGetMeData, ThrowOnError>,
): RequestResult<UsersGetMeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersGetMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/me',
    ...options,
  });

export const usersCheckIfDomainAllowed = <ThrowOnError extends boolean = true>(
  options?: Options<UsersCheckIfDomainAllowedData, ThrowOnError>,
): RequestResult<UsersCheckIfDomainAllowedResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<UsersCheckIfDomainAllowedResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/checkIfDomainAllowed',
    ...options,
  });

export const usersUpdateProfile = <ThrowOnError extends boolean = true>(
  options?: Options<UsersUpdateProfileData, ThrowOnError>,
): RequestResult<UsersUpdateProfileResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).put<UsersUpdateProfileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/updateProfile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const usersCreateOrganization = <ThrowOnError extends boolean = true>(
  options?: Options<UsersCreateOrganizationData, ThrowOnError>,
): RequestResult<UsersCreateOrganizationResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<UsersCreateOrganizationResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/createOrganization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const usersUpdateProjectBookmarks = <ThrowOnError extends boolean = true>(
  options?: Options<UsersUpdateProjectBookmarksData, ThrowOnError>,
): RequestResult<UsersUpdateProjectBookmarksResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).put<UsersUpdateProjectBookmarksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/users/preferences/projectBookmarks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const verificationHandleWebhook = <ThrowOnError extends boolean = true>(
  options?: Options<VerificationHandleWebhookData, ThrowOnError>,
): RequestResult<VerificationHandleWebhookResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<VerificationHandleWebhookResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/verification/handleVerificationWebhook',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const civilsearchGetSupportingFiles = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetSupportingFilesData, ThrowOnError>,
): RequestResult<CivilsearchGetSupportingFilesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetSupportingFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/files',
    ...options,
  });

export const civilsearchGetCivilSearchFileDownloadUrl = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetCivilSearchFileDownloadUrlData, ThrowOnError>,
): RequestResult<CivilsearchGetCivilSearchFileDownloadUrlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetCivilSearchFileDownloadUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/files/{fileType}/{fileId}/downloadUrl',
    ...options,
  });

export const civilsearchAddSupportingFile = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddSupportingFileData, ThrowOnError>,
): RequestResult<CivilsearchAddSupportingFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddSupportingFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/supportingFiles',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const civilsearchDeleteSupportingFile = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchDeleteSupportingFileData, ThrowOnError>,
): RequestResult<CivilsearchDeleteSupportingFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CivilsearchDeleteSupportingFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/supportingFiles/{fileId}',
    ...options,
  });

export const civilsearchAddDataRequestFile = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddDataRequestFileData, ThrowOnError>,
): RequestResult<CivilsearchAddDataRequestFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddDataRequestFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequestFiles',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const civilsearchDeleteDataRequestFile = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchDeleteDataRequestFileData, ThrowOnError>,
): RequestResult<CivilsearchDeleteDataRequestFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CivilsearchDeleteDataRequestFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequestFiles/{fileId}',
    ...options,
  });

export const civilsearchUpdateRequestFileReferences = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateRequestFileReferencesData, ThrowOnError>,
): RequestResult<CivilsearchUpdateRequestFileReferencesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateRequestFileReferencesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/files/{fileId}/updateRequestFileReferences',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchGetAgencies = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchGetAgenciesData, ThrowOnError>,
): RequestResult<CivilsearchGetAgenciesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CivilsearchGetAgenciesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies',
    ...options,
  });

export const civilsearchListFilteredAgencies = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchListFilteredAgenciesData, ThrowOnError>,
): RequestResult<CivilsearchListFilteredAgenciesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchListFilteredAgenciesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/listFilteredAgencies',
    ...options,
  });

export const civilsearchMergeAgencies = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchMergeAgenciesData, ThrowOnError>,
): RequestResult<CivilsearchMergeAgenciesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CivilsearchMergeAgenciesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/merge',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const civilsearchMergeAgenciesPreview = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchMergeAgenciesPreviewData, ThrowOnError>,
): RequestResult<CivilsearchMergeAgenciesPreviewResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CivilsearchMergeAgenciesPreviewResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/merge/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const civilsearchGetAgency = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetAgencyData, ThrowOnError>,
): RequestResult<CivilsearchGetAgencyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetAgencyResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}',
    ...options,
  });

export const civilsearchUpdateAgency = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateAgencyData, ThrowOnError>,
): RequestResult<CivilsearchUpdateAgencyResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateAgencyResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchGetAgencyGeometries = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetAgencyGeometriesData, ThrowOnError>,
): RequestResult<CivilsearchGetAgencyGeometriesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetAgencyGeometriesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/geometries',
    ...options,
  });

export const civilsearchGetAgencySubGeometries = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetAgencySubGeometriesData, ThrowOnError>,
): RequestResult<CivilsearchGetAgencySubGeometriesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetAgencySubGeometriesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/subGeometries',
    ...options,
  });

export const civilsearchCreateAgencySubGeometry = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchCreateAgencySubGeometryData, ThrowOnError>,
): RequestResult<CivilsearchCreateAgencySubGeometryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchCreateAgencySubGeometryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/subGeometries',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchArchiveAgencySubGeometry = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchArchiveAgencySubGeometryData, ThrowOnError>,
): RequestResult<CivilsearchArchiveAgencySubGeometryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CivilsearchArchiveAgencySubGeometryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/subGeometries/{subGeometryId}',
    ...options,
  });

export const civilsearchUpdateAgencySubGeometry = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateAgencySubGeometryData, ThrowOnError>,
): RequestResult<CivilsearchUpdateAgencySubGeometryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateAgencySubGeometryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/subGeometries/{subGeometryId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchUpdateAgencySubGeometryNote = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateAgencySubGeometryNoteData, ThrowOnError>,
): RequestResult<CivilsearchUpdateAgencySubGeometryNoteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateAgencySubGeometryNoteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/subGeometries/{subGeometryId}/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchGetMergeHistory = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetMergeHistoryData, ThrowOnError>,
): RequestResult<CivilsearchGetMergeHistoryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetMergeHistoryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/mergeHistory',
    ...options,
  });

export const civilsearchAddAgencyLogo = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddAgencyLogoData, ThrowOnError>,
): RequestResult<CivilsearchAddAgencyLogoResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddAgencyLogoResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/logo',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const civilsearchAddAgencyLink = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddAgencyLinkData, ThrowOnError>,
): RequestResult<CivilsearchAddAgencyLinkResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddAgencyLinkResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/agencyLink',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchDeleteAgencyLink = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchDeleteAgencyLinkData, ThrowOnError>,
): RequestResult<CivilsearchDeleteAgencyLinkResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CivilsearchDeleteAgencyLinkResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/agencyLink/{linkId}',
    ...options,
  });

export const civilsearchEditAgencyLink = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchEditAgencyLinkData, ThrowOnError>,
): RequestResult<CivilsearchEditAgencyLinkResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchEditAgencyLinkResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/agencyLink/{linkId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchAddDigitizationAccess = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddDigitizationAccessData, ThrowOnError>,
): RequestResult<CivilsearchAddDigitizationAccessResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddDigitizationAccessResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/digitization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchRemoveDigitizationAccess = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchRemoveDigitizationAccessData, ThrowOnError>,
): RequestResult<CivilsearchRemoveDigitizationAccessResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CivilsearchRemoveDigitizationAccessResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencies/{agencyId}/digitization/{digitizationId}',
    ...options,
  });

export const civilsearchNewAgencyContact = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchNewAgencyContactData, ThrowOnError>,
): RequestResult<CivilsearchNewAgencyContactResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CivilsearchNewAgencyContactResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencyContacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const civilsearchUpdateAgencyContact = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateAgencyContactData, ThrowOnError>,
): RequestResult<CivilsearchUpdateAgencyContactResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateAgencyContactResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/agencyContacts/{contactId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchGetDataRequests = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchGetDataRequestsData, ThrowOnError>,
): RequestResult<CivilsearchGetDataRequestsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CivilsearchGetDataRequestsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests',
    ...options,
  });

export const civilsearchListFilteredDataRequests = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchListFilteredDataRequestsData, ThrowOnError>,
): RequestResult<CivilsearchListFilteredDataRequestsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchListFilteredDataRequestsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/listFilteredDataRequests',
    ...options,
  });

export const civilsearchGetDataRequest = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetDataRequestData, ThrowOnError>,
): RequestResult<CivilsearchGetDataRequestResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetDataRequestResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}',
    ...options,
  });

export const civilsearchUpdateDataRequest = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateDataRequestData, ThrowOnError>,
): RequestResult<CivilsearchUpdateDataRequestResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateDataRequestResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchBulkUpdateDataRequests = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchBulkUpdateDataRequestsData, ThrowOnError>,
): RequestResult<CivilsearchBulkUpdateDataRequestsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).put<CivilsearchBulkUpdateDataRequestsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/bulkUpdate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const civilsearchBulkCreateDataRequestNotes = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchBulkCreateDataRequestNotesData, ThrowOnError>,
): RequestResult<CivilsearchBulkCreateDataRequestNotesResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CivilsearchBulkCreateDataRequestNotesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/bulkNotes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const civilsearchAddDataRequestUpdate = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddDataRequestUpdateData, ThrowOnError>,
): RequestResult<CivilsearchAddDataRequestUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddDataRequestUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/updates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchDeleteDataRequestUpdate = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchDeleteDataRequestUpdateData, ThrowOnError>,
): RequestResult<CivilsearchDeleteDataRequestUpdateResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CivilsearchDeleteDataRequestUpdateResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/updates/{updateId}',
    ...options,
  });

export const civilsearchAddDataRequestNote = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddDataRequestNoteData, ThrowOnError>,
): RequestResult<CivilsearchAddDataRequestNoteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddDataRequestNoteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchDeleteDataRequestNote = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchDeleteDataRequestNoteData, ThrowOnError>,
): RequestResult<CivilsearchDeleteDataRequestNoteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CivilsearchDeleteDataRequestNoteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/notes/{noteId}',
    ...options,
  });

export const civilsearchUpdateDataRequestNote = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateDataRequestNoteData, ThrowOnError>,
): RequestResult<CivilsearchUpdateDataRequestNoteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateDataRequestNoteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/notes/{noteId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchAddNewInvoice = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddNewInvoiceData, ThrowOnError>,
): RequestResult<CivilsearchAddNewInvoiceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddNewInvoiceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/invoices',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchUpdateInvoice = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateInvoiceData, ThrowOnError>,
): RequestResult<CivilsearchUpdateInvoiceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateInvoiceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/invoices/{invoiceId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchCreateMissiveEmailDraft = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchCreateMissiveEmailDraftData, ThrowOnError>,
): RequestResult<CivilsearchCreateMissiveEmailDraftResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchCreateMissiveEmailDraftResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/createMissiveEmailDraft',
    ...options,
  });

export const civilsearchGetRecordRequestData = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetRecordRequestDataData, ThrowOnError>,
): RequestResult<CivilsearchGetRecordRequestDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetRecordRequestDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/dataRequests/{requestId}/recordRequestData',
    ...options,
  });

export const civilsearchGetCivilSearchMessages = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetCivilSearchMessagesData, ThrowOnError>,
): RequestResult<CivilsearchGetCivilSearchMessagesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetCivilSearchMessagesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/civilSearchMessages',
    ...options,
  });

export const civilsearchAddCivilSearchMessage = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddCivilSearchMessageData, ThrowOnError>,
): RequestResult<CivilsearchAddCivilSearchMessageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddCivilSearchMessageResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/civilSearchMessages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchAddCivilSearchMessageFile = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchAddCivilSearchMessageFileData, ThrowOnError>,
): RequestResult<CivilsearchAddCivilSearchMessageFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CivilsearchAddCivilSearchMessageFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/civilSearchMessages/{messageId}/files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const civilsearchSearchProjects = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchSearchProjectsData, ThrowOnError>,
): RequestResult<CivilsearchSearchProjectsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CivilsearchSearchProjectsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/projects/search',
    ...options,
  });

export const civilsearchGetProject = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetProjectData, ThrowOnError>,
): RequestResult<CivilsearchGetProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/projects/{projectId}',
    ...options,
  });

export const civilsearchSearchOrganizations = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchSearchOrganizationsData, ThrowOnError>,
): RequestResult<CivilsearchSearchOrganizationsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CivilsearchSearchOrganizationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/organizations/search',
    ...options,
  });

export const civilsearchListFilteredProjects = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchListFilteredProjectsData, ThrowOnError>,
): RequestResult<CivilsearchListFilteredProjectsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchListFilteredProjectsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/listFilteredProjects',
    ...options,
  });

export const civilsearchUpdateRequestAssignmentsByProjectId = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchUpdateRequestAssignmentsByProjectIdData, ThrowOnError>,
): RequestResult<CivilsearchUpdateRequestAssignmentsByProjectIdResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<CivilsearchUpdateRequestAssignmentsByProjectIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/projects/{projectId}/updateRequestAssignments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const civilsearchGetAiProjectDescription = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetAiProjectDescriptionData, ThrowOnError>,
): RequestResult<CivilsearchGetAiProjectDescriptionResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetAiProjectDescriptionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/projects/{projectId}/getAiProjectDescription',
    ...options,
  });

export const civilsearchGetProjectUtilityChecks = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetProjectUtilityChecksData, ThrowOnError>,
): RequestResult<CivilsearchGetProjectUtilityChecksResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetProjectUtilityChecksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/projectUtilityChecks',
    ...options,
  });

export const civilsearchGetUtilityChecksByProject = <ThrowOnError extends boolean = true>(
  options: Options<CivilsearchGetUtilityChecksByProjectData, ThrowOnError>,
): RequestResult<CivilsearchGetUtilityChecksByProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CivilsearchGetUtilityChecksByProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/utilityChecks',
    ...options,
  });

export const civilsearchCreateUtilityChecks = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchCreateUtilityChecksData, ThrowOnError>,
): RequestResult<CivilsearchCreateUtilityChecksResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CivilsearchCreateUtilityChecksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/utilityChecks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const civilsearchGetCivilSearchers = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchGetCivilSearchersData, ThrowOnError>,
): RequestResult<CivilsearchGetCivilSearchersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).get<CivilsearchGetCivilSearchersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/civilSearchers',
    ...options,
  });

export const civilsearchUpdateCivilSearchers = <ThrowOnError extends boolean = true>(
  options?: Options<CivilsearchUpdateCivilSearchersData, ThrowOnError>,
): RequestResult<CivilsearchUpdateCivilSearchersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).put<CivilsearchUpdateCivilSearchersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/civilsearch/civilSearchers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const filesAddSingleFile = <ThrowOnError extends boolean = true>(
  options: Options<FilesAddSingleFileData, ThrowOnError>,
): RequestResult<FilesAddSingleFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<FilesAddSingleFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/files/',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const filesDeleteSingleFile = <ThrowOnError extends boolean = true>(
  options: Options<FilesDeleteSingleFileData, ThrowOnError>,
): RequestResult<FilesDeleteSingleFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<FilesDeleteSingleFileResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/files/{fileId}',
    ...options,
  });

export const miscV2PrintMap = <ThrowOnError extends boolean = true>(
  options?: Options<MiscV2PrintMapData, ThrowOnError>,
): RequestResult<MiscV2PrintMapResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<MiscV2PrintMapResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/misc/printMap',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const miscV2IsUrbanArea = <ThrowOnError extends boolean = true>(
  options?: Options<MiscV2IsUrbanAreaData, ThrowOnError>,
): RequestResult<MiscV2IsUrbanAreaResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<MiscV2IsUrbanAreaResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/misc/isUrbanArea',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const miscV2GetParcelSuggestions = <ThrowOnError extends boolean = true>(
  options: Options<MiscV2GetParcelSuggestionsData, ThrowOnError>,
): RequestResult<MiscV2GetParcelSuggestionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<MiscV2GetParcelSuggestionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/misc/parcelSuggestions',
    ...options,
  });

export const miscV2GetProjectionList = <ThrowOnError extends boolean = true>(
  options: Options<MiscV2GetProjectionListData, ThrowOnError>,
): RequestResult<MiscV2GetProjectionListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<MiscV2GetProjectionListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/misc/getProjectionList',
    ...options,
  });

export const miscV2GetAgenciesSummary = <ThrowOnError extends boolean = true>(
  options?: Options<MiscV2GetAgenciesSummaryData, ThrowOnError>,
): RequestResult<MiscV2GetAgenciesSummaryResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<MiscV2GetAgenciesSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/misc/getAgenciesSummary',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const miscV2GetZoningDetailsAtPoint = <ThrowOnError extends boolean = true>(
  options: Options<MiscV2GetZoningDetailsAtPointData, ThrowOnError>,
): RequestResult<MiscV2GetZoningDetailsAtPointResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<MiscV2GetZoningDetailsAtPointResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/misc/getZoningDetailsAtPoint',
    ...options,
  });

export const miscV2TranscodeImage = <ThrowOnError extends boolean = true>(
  options: Options<MiscV2TranscodeImageData, ThrowOnError>,
): RequestResult<MiscV2TranscodeImageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<MiscV2TranscodeImageResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/misc/transcodeImage',
    ...options,
  });

export const miscV2ValidateGeometry = <ThrowOnError extends boolean = true>(
  options?: Options<MiscV2ValidateGeometryData, ThrowOnError>,
): RequestResult<MiscV2ValidateGeometryResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<MiscV2ValidateGeometryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/misc/validateGeometry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const projectsV2ListIntelligenceSummaries = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2ListIntelligenceSummariesData, ThrowOnError>,
): RequestResult<ProjectsV2ListIntelligenceSummariesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2ListIntelligenceSummariesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/intelligenceSummary',
    ...options,
  });

export const projectsV2ExportIntelligenceSummariesToExcel = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsV2ExportIntelligenceSummariesToExcelData, ThrowOnError>,
): RequestResult<ProjectsV2ExportIntelligenceSummariesToExcelResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ProjectsV2ExportIntelligenceSummariesToExcelResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/intelligenceSummary/export/excel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const projectsV2UpdateIntelligenceSummary = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UpdateIntelligenceSummaryData, ThrowOnError>,
): RequestResult<ProjectsV2UpdateIntelligenceSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2UpdateIntelligenceSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/intelligenceSummary/{summaryId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2ListProjectsV2 = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2ListProjectsV2Data, ThrowOnError>,
): RequestResult<ProjectsV2ListProjectsV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2ListProjectsV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/',
    ...options,
  });

export const projectsV2AddProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2AddProjectData, ThrowOnError>,
): RequestResult<ProjectsV2AddProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2AddProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2ArchiveProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2ArchiveProjectData, ThrowOnError>,
): RequestResult<ProjectsV2ArchiveProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2ArchiveProjectResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}',
    ...options,
  });

export const projectsV2GetProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetProjectData, ThrowOnError>,
): RequestResult<ProjectsV2GetProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}',
    ...options,
  });

export const projectsV2EditProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2EditProjectData, ThrowOnError>,
): RequestResult<ProjectsV2EditProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2EditProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2UpdateBillingTier = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UpdateBillingTierData, ThrowOnError>,
): RequestResult<ProjectsV2UpdateBillingTierResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2UpdateBillingTierResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/updateBillingTier',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2EditProjectGeometry = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2EditProjectGeometryData, ThrowOnError>,
): RequestResult<ProjectsV2EditProjectGeometryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2EditProjectGeometryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/editProjectGeometry',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2AddMembers = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2AddMembersData, ThrowOnError>,
): RequestResult<ProjectsV2AddMembersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2AddMembersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/members',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2JoinProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2JoinProjectData, ThrowOnError>,
): RequestResult<ProjectsV2JoinProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2JoinProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/join',
    ...options,
  });

export const projectsV2LeaveProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2LeaveProjectData, ThrowOnError>,
): RequestResult<ProjectsV2LeaveProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2LeaveProjectResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/leave',
    ...options,
  });

export const projectsV2RemoveMember = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2RemoveMemberData, ThrowOnError>,
): RequestResult<ProjectsV2RemoveMemberResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2RemoveMemberResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/members/{memberId}',
    ...options,
  });

export const projectsV2GetParcelData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetParcelDataData, ThrowOnError>,
): RequestResult<ProjectsV2GetParcelDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetParcelDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/getParcelData/{lng}/{lat}',
    ...options,
  });

export const projectsV2ListMaps = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2ListMapsData, ThrowOnError>,
): RequestResult<ProjectsV2ListMapsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2ListMapsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps',
    ...options,
  });

export const projectsV2AddMap = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2AddMapData, ThrowOnError>,
): RequestResult<ProjectsV2AddMapResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2AddMapResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2DuplicateMap = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2DuplicateMapData, ThrowOnError>,
): RequestResult<ProjectsV2DuplicateMapResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2DuplicateMapResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/duplicate',
    ...options,
  });

export const projectsV2DeleteMap = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2DeleteMapData, ThrowOnError>,
): RequestResult<ProjectsV2DeleteMapResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2DeleteMapResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}',
    ...options,
  });

export const projectsV2GetMap = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetMapData, ThrowOnError>,
): RequestResult<ProjectsV2GetMapResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetMapResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}',
    ...options,
  });

export const projectsV2UpdateMap = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UpdateMapData, ThrowOnError>,
): RequestResult<ProjectsV2UpdateMapResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2UpdateMapResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2AddObject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2AddObjectData, ThrowOnError>,
): RequestResult<ProjectsV2AddObjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2AddObjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/object',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2AddObjects = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2AddObjectsData, ThrowOnError>,
): RequestResult<ProjectsV2AddObjectsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2AddObjectsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2DeleteObject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2DeleteObjectData, ThrowOnError>,
): RequestResult<ProjectsV2DeleteObjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2DeleteObjectResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects/{objectId}',
    ...options,
  });

export const projectsV2UndoDeleteObject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UndoDeleteObjectData, ThrowOnError>,
): RequestResult<ProjectsV2UndoDeleteObjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ProjectsV2UndoDeleteObjectResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects/{objectId}',
    ...options,
  });

export const projectsV2UpdateObject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UpdateObjectData, ThrowOnError>,
): RequestResult<ProjectsV2UpdateObjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2UpdateObjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects/{objectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2DeleteObjectFiles = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2DeleteObjectFilesData, ThrowOnError>,
): RequestResult<ProjectsV2DeleteObjectFilesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2DeleteObjectFilesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects/{objectId}/files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2AddObjectFile = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2AddObjectFileData, ThrowOnError>,
): RequestResult<ProjectsV2AddObjectFileResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2AddObjectFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects/{objectId}/files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const projectsV2AddComment = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2AddCommentData, ThrowOnError>,
): RequestResult<ProjectsV2AddCommentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2AddCommentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects/{objectId}/comment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2ArchiveComment = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2ArchiveCommentData, ThrowOnError>,
): RequestResult<ProjectsV2ArchiveCommentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2ArchiveCommentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects/{objectId}/comment/{commentId}',
    ...options,
  });

export const projectsV2UpdateComment = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UpdateCommentData, ThrowOnError>,
): RequestResult<ProjectsV2UpdateCommentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ProjectsV2UpdateCommentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/maps/{mapId}/objects/{objectId}/comment/{commentId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2DeletePermit = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2DeletePermitData, ThrowOnError>,
): RequestResult<ProjectsV2DeletePermitResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2DeletePermitResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/permit',
    ...options,
  });

export const projectsV2GetPermit = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetPermitData, ThrowOnError>,
): RequestResult<ProjectsV2GetPermitResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetPermitResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/permit',
    ...options,
  });

export const projectsV2UpsertPermit = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UpsertPermitData, ThrowOnError>,
): RequestResult<ProjectsV2UpsertPermitResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2UpsertPermitResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/permit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2ListTransactions = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2ListTransactionsData, ThrowOnError>,
): RequestResult<ProjectsV2ListTransactionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2ListTransactionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/transactions',
    ...options,
  });

export const projectsV2PrintReceipt = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2PrintReceiptData, ThrowOnError>,
): RequestResult<ProjectsV2PrintReceiptResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2PrintReceiptResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/printReceipt',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2PrintQuote = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2PrintQuoteData, ThrowOnError>,
): RequestResult<ProjectsV2PrintQuoteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2PrintQuoteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/printQuote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GetIntelligenceFeatures = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetIntelligenceFeaturesData, ThrowOnError>,
): RequestResult<ProjectsV2GetIntelligenceFeaturesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetIntelligenceFeaturesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getIntelligenceFeatures',
    ...options,
  });

export const projectsV2UpdateIntelligenceStatus = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UpdateIntelligenceStatusData, ThrowOnError>,
): RequestResult<ProjectsV2UpdateIntelligenceStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2UpdateIntelligenceStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/updateIntelligenceStatus',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GenerateProposalPacket = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GenerateProposalPacketData, ThrowOnError>,
): RequestResult<ProjectsV2GenerateProposalPacketResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2GenerateProposalPacketResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/generateProposalPacket',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GenerateRecordsResearchReport = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GenerateRecordsResearchReportData, ThrowOnError>,
): RequestResult<ProjectsV2GenerateRecordsResearchReportResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2GenerateRecordsResearchReportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/generateRecordsResearchReport',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GetProjectDownloads = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetProjectDownloadsData, ThrowOnError>,
): RequestResult<ProjectsV2GetProjectDownloadsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetProjectDownloadsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/download',
    ...options,
  });

export const projectsV2GetDownloadSignedUrl = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetDownloadSignedUrlData, ThrowOnError>,
): RequestResult<ProjectsV2GetDownloadSignedUrlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetDownloadSignedUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/downloads/{downloadId}/signedUrl',
    ...options,
  });

export const projectsV2GetUtilitiesFileSignedUrl = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetUtilitiesFileSignedUrlData, ThrowOnError>,
): RequestResult<ProjectsV2GetUtilitiesFileSignedUrlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetUtilitiesFileSignedUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/utilities/files/{source}/{fileId}/signedUrl',
    ...options,
  });

export const projectsV2GetStoredFileDownloadUrl = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetStoredFileDownloadUrlData, ThrowOnError>,
): RequestResult<ProjectsV2GetStoredFileDownloadUrlResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetStoredFileDownloadUrlResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/files/{fileType}/{fileId}/downloadUrl',
    ...options,
  });

export const projectsV2AddIntelligenceComment = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2AddIntelligenceCommentData, ThrowOnError>,
): RequestResult<ProjectsV2AddIntelligenceCommentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2AddIntelligenceCommentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/addIntelligenceComment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2DeleteIntelligenceComment = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2DeleteIntelligenceCommentData, ThrowOnError>,
): RequestResult<ProjectsV2DeleteIntelligenceCommentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV2DeleteIntelligenceCommentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/deleteIntelligenceComment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2SubmitDownloadRequest = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2SubmitDownloadRequestData, ThrowOnError>,
): RequestResult<ProjectsV2SubmitDownloadRequestResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2SubmitDownloadRequestResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/submitDownloadRequest',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GetUtilityAgencies = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetUtilityAgenciesData, ThrowOnError>,
): RequestResult<ProjectsV2GetUtilityAgenciesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2GetUtilityAgenciesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getUtilityAgencies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GetDataRequestsV2 = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetDataRequestsV2Data, ThrowOnError>,
): RequestResult<ProjectsV2GetDataRequestsV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetDataRequestsV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getDataRequestsV2',
    ...options,
  });

export const projectsV2SubmitDataRequestsV2 = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2SubmitDataRequestsV2Data, ThrowOnError>,
): RequestResult<ProjectsV2SubmitDataRequestsV2Responses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2SubmitDataRequestsV2Responses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/submitDataRequestsV2',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GetCivilSearchMessages = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetCivilSearchMessagesData, ThrowOnError>,
): RequestResult<ProjectsV2GetCivilSearchMessagesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetCivilSearchMessagesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/civilSearchMessages',
    ...options,
  });

export const projectsV2NewCivilSearchMessage = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2NewCivilSearchMessageData, ThrowOnError>,
): RequestResult<ProjectsV2NewCivilSearchMessageResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2NewCivilSearchMessageResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/civilSearchMessages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GetCivilSearchActivities = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetCivilSearchActivitiesData, ThrowOnError>,
): RequestResult<ProjectsV2GetCivilSearchActivitiesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetCivilSearchActivitiesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getCivilSearchActivities',
    ...options,
  });

export const projectsV2GetLatestCivilSearchActivity = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetLatestCivilSearchActivityData, ThrowOnError>,
): RequestResult<ProjectsV2GetLatestCivilSearchActivityResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetLatestCivilSearchActivityResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/latestCivilSearchActivity',
    ...options,
  });

export const projectsV2GetLayers = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetLayersData, ThrowOnError>,
): RequestResult<ProjectsV2GetLayersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetLayersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getLayers',
    ...options,
  });

export const projectsV2GetDownloadRestrictions = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetDownloadRestrictionsData, ThrowOnError>,
): RequestResult<ProjectsV2GetDownloadRestrictionsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetDownloadRestrictionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getDownloadRestrictions',
    ...options,
  });

export const projectsV2GetDigitizationAccess = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetDigitizationAccessData, ThrowOnError>,
): RequestResult<ProjectsV2GetDigitizationAccessResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetDigitizationAccessResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getDigitizationAccess',
    ...options,
  });

export const projectsV2GetProjectLayerAssetPresence = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetProjectLayerAssetPresenceData, ThrowOnError>,
): RequestResult<ProjectsV2GetProjectLayerAssetPresenceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2GetProjectLayerAssetPresenceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/layerAssetPresence',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GenerateFloodReport = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GenerateFloodReportData, ThrowOnError>,
): RequestResult<ProjectsV2GenerateFloodReportResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2GenerateFloodReportResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/generateFloodReport',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GetHistoricalUsgsMaps = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetHistoricalUsgsMapsData, ThrowOnError>,
): RequestResult<ProjectsV2GetHistoricalUsgsMapsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetHistoricalUsgsMapsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getHistoricalUSGSMaps',
    ...options,
  });

export const projectsV2GetCgsRegulatoryQuadrangleList = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetCgsRegulatoryQuadrangleListData, ThrowOnError>,
): RequestResult<ProjectsV2GetCgsRegulatoryQuadrangleListResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetCgsRegulatoryQuadrangleListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getCGSRegulatoryQuadrangleList',
    ...options,
  });

export const projectsV2GenerateEvidenceEmailChain = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GenerateEvidenceEmailChainData, ThrowOnError>,
): RequestResult<ProjectsV2GenerateEvidenceEmailChainResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2GenerateEvidenceEmailChainResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/generateEvidenceEmailChain',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2UpdateUtilityNote = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2UpdateUtilityNoteData, ThrowOnError>,
): RequestResult<ProjectsV2UpdateUtilityNoteResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV2UpdateUtilityNoteResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/utilityNotes/{utilityNoteId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2DownloadCsAttachments = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2DownloadCsAttachmentsData, ThrowOnError>,
): RequestResult<ProjectsV2DownloadCsAttachmentsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2DownloadCsAttachmentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/downloadCSAttachments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV2GetAntennaData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetAntennaDataData, ThrowOnError>,
): RequestResult<ProjectsV2GetAntennaDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetAntennaDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/antennaMap',
    ...options,
  });

export const projectsV2GetEnvironmentalStudyData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetEnvironmentalStudyDataData, ThrowOnError>,
): RequestResult<ProjectsV2GetEnvironmentalStudyDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetEnvironmentalStudyDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getEnvironmentalStudyData',
    ...options,
  });

export const projectsV2GetEnvironmentalStudyPdf = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetEnvironmentalStudyPdfData, ThrowOnError>,
): RequestResult<ProjectsV2GetEnvironmentalStudyPdfResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetEnvironmentalStudyPdfResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getEnvironmentalStudyPDF',
    ...options,
  });

export const projectsV2RequestErisData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2RequestErisDataData, ThrowOnError>,
): RequestResult<ProjectsV2RequestErisDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2RequestErisDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/requestErisData',
    ...options,
  });

export const projectsV2GetLandRightsSummary = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetLandRightsSummaryData, ThrowOnError>,
): RequestResult<ProjectsV2GetLandRightsSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetLandRightsSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getLandRightsSummary',
    ...options,
  });

export const projectsV2GetGeotechnicalSummary = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetGeotechnicalSummaryData, ThrowOnError>,
): RequestResult<ProjectsV2GetGeotechnicalSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetGeotechnicalSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getGeotechnicalSummary',
    ...options,
  });

export const projectsV2GetEnvironmentalSummary = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetEnvironmentalSummaryData, ThrowOnError>,
): RequestResult<ProjectsV2GetEnvironmentalSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetEnvironmentalSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getEnvironmentalSummary',
    ...options,
  });

export const projectsV2GetUtilitiesSummary = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetUtilitiesSummaryData, ThrowOnError>,
): RequestResult<ProjectsV2GetUtilitiesSummaryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetUtilitiesSummaryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/getUtilitiesSummary',
    ...options,
  });

export const projectsV2GetProjectAgencies = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2GetProjectAgenciesData, ThrowOnError>,
): RequestResult<ProjectsV2GetProjectAgenciesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV2GetProjectAgenciesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/agencies',
    ...options,
  });

export const projectsV2PopulateProjectAgenciesData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV2PopulateProjectAgenciesDataData, ThrowOnError>,
): RequestResult<ProjectsV2PopulateProjectAgenciesDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV2PopulateProjectAgenciesDataResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v2/projects/{projectId}/agencies',
    ...options,
  });

export const authV3GetAuthCode = <ThrowOnError extends boolean = true>(
  options?: Options<AuthV3GetAuthCodeData, ThrowOnError>,
): RequestResult<AuthV3GetAuthCodeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthV3GetAuthCodeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/auth/getAuthCode',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const authV3Login = <ThrowOnError extends boolean = true>(
  options?: Options<AuthV3LoginData, ThrowOnError>,
): RequestResult<AuthV3LoginResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthV3LoginResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/auth/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const authV3SamlConsume = <ThrowOnError extends boolean = true>(
  options?: Options<AuthV3SamlConsumeData, ThrowOnError>,
): RequestResult<AuthV3SamlConsumeResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthV3SamlConsumeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/auth/saml/consume',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const authV3Register = <ThrowOnError extends boolean = true>(
  options?: Options<AuthV3RegisterData, ThrowOnError>,
): RequestResult<AuthV3RegisterResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthV3RegisterResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/auth/register',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const authV3LogOut = <ThrowOnError extends boolean = true>(
  options?: Options<AuthV3LogOutData, ThrowOnError>,
): RequestResult<AuthV3LogOutResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthV3LogOutResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/auth/logOut',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const authV3JoinOrgByDomain = <ThrowOnError extends boolean = true>(
  options?: Options<AuthV3JoinOrgByDomainData, ThrowOnError>,
): RequestResult<AuthV3JoinOrgByDomainResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<AuthV3JoinOrgByDomainResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/auth/joinOrgByDomain',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const dataStoreMessageHandler = <ThrowOnError extends boolean = true>(
  options?: Options<DataStoreMessageHandlerData, ThrowOnError>,
): RequestResult<DataStoreMessageHandlerResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<DataStoreMessageHandlerResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/dataStore/messageHandler',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const projectsV3ListProjects = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ListProjectsData, ThrowOnError>,
): RequestResult<ProjectsV3ListProjectsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3ListProjectsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/',
    ...options,
  });

export const projectsV3ListIntelligenceSummaries = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ListIntelligenceSummariesData, ThrowOnError>,
): RequestResult<ProjectsV3ListIntelligenceSummariesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3ListIntelligenceSummariesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/intelligenceSummary',
    ...options,
  });

export const projectsV3GetIntelligenceSummaryMeta = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3GetIntelligenceSummaryMetaData, ThrowOnError>,
): RequestResult<ProjectsV3GetIntelligenceSummaryMetaResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3GetIntelligenceSummaryMetaResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/intelligenceSummary/meta',
    ...options,
  });

export const projectsV3ExportIntelligenceSummariesToExcel = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ExportIntelligenceSummariesToExcelData, ThrowOnError>,
): RequestResult<ProjectsV3ExportIntelligenceSummariesToExcelResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV3ExportIntelligenceSummariesToExcelResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/intelligenceSummary/export/xlsx',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3BulkUpdateConstructionDates = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3BulkUpdateConstructionDatesData, ThrowOnError>,
): RequestResult<ProjectsV3BulkUpdateConstructionDatesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV3BulkUpdateConstructionDatesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/intelligenceSummary/bulkUpdateConstructionDates',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3BulkUpdatePlanStatus = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3BulkUpdatePlanStatusData, ThrowOnError>,
): RequestResult<ProjectsV3BulkUpdatePlanStatusResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV3BulkUpdatePlanStatusResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/intelligenceSummary/bulkUpdatePlanStatus',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3ListAllProjects = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ListAllProjectsData, ThrowOnError>,
): RequestResult<ProjectsV3ListAllProjectsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3ListAllProjectsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/allProjects',
    ...options,
  });

export const projectsV3GetSandboxProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3GetSandboxProjectData, ThrowOnError>,
): RequestResult<ProjectsV3GetSandboxProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3GetSandboxProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/sandbox',
    ...options,
  });

export const projectsV3ExportProjectsToExcel = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ExportProjectsToExcelData, ThrowOnError>,
): RequestResult<ProjectsV3ExportProjectsToExcelResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV3ExportProjectsToExcelResponses, unknown, ThrowOnError>({
    responseType: 'blob',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/export/xlsx',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3ToggleProjectBookmark = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ToggleProjectBookmarkData, ThrowOnError>,
): RequestResult<ProjectsV3ToggleProjectBookmarkResponses, unknown, ThrowOnError> =>
  (options.client ?? client).put<ProjectsV3ToggleProjectBookmarkResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/bookmark',
    ...options,
  });

export const projectsV3BulkUpdateProjects = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsV3BulkUpdateProjectsData, ThrowOnError>,
): RequestResult<ProjectsV3BulkUpdateProjectsResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ProjectsV3BulkUpdateProjectsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/bulkUpdate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const projectsV3BulkAddProjectBookmarks = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsV3BulkAddProjectBookmarksData, ThrowOnError>,
): RequestResult<ProjectsV3BulkAddProjectBookmarksResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ProjectsV3BulkAddProjectBookmarksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/bulkBookmark',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const projectsV3InviteMembers = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsV3InviteMembersData, ThrowOnError>,
): RequestResult<ProjectsV3InviteMembersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ProjectsV3InviteMembersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/inviteMembers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const projectsV3BulkInviteMembers = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsV3BulkInviteMembersData, ThrowOnError>,
): RequestResult<ProjectsV3BulkInviteMembersResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<ProjectsV3BulkInviteMembersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/bulkInvite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const projectsV3InspectWmtsCustomData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3InspectWmtsCustomDataData, ThrowOnError>,
): RequestResult<ProjectsV3InspectWmtsCustomDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV3InspectWmtsCustomDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data/wmts/inspect',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3AddWmtsCustomData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3AddWmtsCustomDataData, ThrowOnError>,
): RequestResult<ProjectsV3AddWmtsCustomDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV3AddWmtsCustomDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data/wmts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3AddShapefileCustomData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3AddShapefileCustomDataData, ThrowOnError>,
): RequestResult<ProjectsV3AddShapefileCustomDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<ProjectsV3AddShapefileCustomDataResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data/shapefile',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const projectsV3ListCustomData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ListCustomDataData, ThrowOnError>,
): RequestResult<ProjectsV3ListCustomDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3ListCustomDataResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data',
    ...options,
  });

export const projectsV3ListProjectAgencyHistory = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ListProjectAgencyHistoryData, ThrowOnError>,
): RequestResult<ProjectsV3ListProjectAgencyHistoryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3ListProjectAgencyHistoryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/agency-history',
    ...options,
  });

export const projectsV3ListProjectConnectbaseTasks = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ListProjectConnectbaseTasksData, ThrowOnError>,
): RequestResult<ProjectsV3ListProjectConnectbaseTasksResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3ListProjectConnectbaseTasksResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/connectbase-tasks',
    ...options,
  });

export const projectsV3SetCustomDataVisibility = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3SetCustomDataVisibilityData, ThrowOnError>,
): RequestResult<ProjectsV3SetCustomDataVisibilityResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ProjectsV3SetCustomDataVisibilityResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data/{id}/visibility',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3SetCustomDataLabel = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3SetCustomDataLabelData, ThrowOnError>,
): RequestResult<ProjectsV3SetCustomDataLabelResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ProjectsV3SetCustomDataLabelResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data/{id}/label',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3SetCustomDataCategories = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3SetCustomDataCategoriesData, ThrowOnError>,
): RequestResult<ProjectsV3SetCustomDataCategoriesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<ProjectsV3SetCustomDataCategoriesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data/{id}/categories',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const projectsV3DownloadCustomDataSource = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3DownloadCustomDataSourceData, ThrowOnError>,
): RequestResult<ProjectsV3DownloadCustomDataSourceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3DownloadCustomDataSourceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data/{id}/download',
    ...options,
  });

export const projectsV3ListGeoRefMapsForProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3ListGeoRefMapsForProjectData, ThrowOnError>,
): RequestResult<ProjectsV3ListGeoRefMapsForProjectResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3ListGeoRefMapsForProjectResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/georeferenced-maps',
    ...options,
  });

export const projectsV3DeleteCustomData = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3DeleteCustomDataData, ThrowOnError>,
): RequestResult<ProjectsV3DeleteCustomDataResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<ProjectsV3DeleteCustomDataResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/custom-data/{id}',
    ...options,
  });

export const projectsV3GetProjectIntelligence = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsV3GetProjectIntelligenceData, ThrowOnError>,
): RequestResult<ProjectsV3GetProjectIntelligenceResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<ProjectsV3GetProjectIntelligenceResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/projects/{projectId}/intelligence',
    ...options,
  });

export const drawingsV3ListDrawings = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3ListDrawingsData, ThrowOnError>,
): RequestResult<DrawingsV3ListDrawingsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DrawingsV3ListDrawingsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/',
    ...options,
  });

export const drawingsV3CreateDrawing = <ThrowOnError extends boolean = true>(
  options?: Options<DrawingsV3CreateDrawingData, ThrowOnError>,
): RequestResult<DrawingsV3CreateDrawingResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<DrawingsV3CreateDrawingResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const drawingsV3ArchiveDrawing = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3ArchiveDrawingData, ThrowOnError>,
): RequestResult<DrawingsV3ArchiveDrawingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<DrawingsV3ArchiveDrawingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/{drawingId}',
    ...options,
  });

export const drawingsV3GetDrawing = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3GetDrawingData, ThrowOnError>,
): RequestResult<DrawingsV3GetDrawingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DrawingsV3GetDrawingResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/{drawingId}',
    ...options,
  });

export const drawingsV3UpdateDrawing = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3UpdateDrawingData, ThrowOnError>,
): RequestResult<DrawingsV3UpdateDrawingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<DrawingsV3UpdateDrawingResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/{drawingId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const drawingsV3ListChanges = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3ListChangesData, ThrowOnError>,
): RequestResult<DrawingsV3ListChangesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DrawingsV3ListChangesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/{drawingId}/changes',
    ...options,
  });

export const drawingsV3ApplyChanges = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3ApplyChangesData, ThrowOnError>,
): RequestResult<DrawingsV3ApplyChangesResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DrawingsV3ApplyChangesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/{drawingId}/changes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const drawingsV3RestoreDrawing = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3RestoreDrawingData, ThrowOnError>,
): RequestResult<DrawingsV3RestoreDrawingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DrawingsV3RestoreDrawingResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/{drawingId}/restore',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const drawingsV3GetHistory = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3GetHistoryData, ThrowOnError>,
): RequestResult<DrawingsV3GetHistoryResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<DrawingsV3GetHistoryResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/{drawingId}/history',
    ...options,
  });

export const drawingsV3DuplicateDrawing = <ThrowOnError extends boolean = true>(
  options: Options<DrawingsV3DuplicateDrawingData, ThrowOnError>,
): RequestResult<DrawingsV3DuplicateDrawingResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<DrawingsV3DuplicateDrawingResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/drawings/{drawingId}/duplicate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const uploadsV3PresignUpload = <ThrowOnError extends boolean = true>(
  options?: Options<UploadsV3PresignUploadData, ThrowOnError>,
): RequestResult<UploadsV3PresignUploadResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<UploadsV3PresignUploadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/uploads/presign',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const uploadsV3RegisterUpload = <ThrowOnError extends boolean = true>(
  options: Options<UploadsV3RegisterUploadData, ThrowOnError>,
): RequestResult<UploadsV3RegisterUploadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<UploadsV3RegisterUploadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/uploads/{uploadId}/register',
    ...options,
  });

export const uploadsV3GetUpload = <ThrowOnError extends boolean = true>(
  options: Options<UploadsV3GetUploadData, ThrowOnError>,
): RequestResult<UploadsV3GetUploadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<UploadsV3GetUploadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/uploads/{uploadId}',
    ...options,
  });

export const commentThreadsV3ListCommentThreads = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3ListCommentThreadsData, ThrowOnError>,
): RequestResult<CommentThreadsV3ListCommentThreadsResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CommentThreadsV3ListCommentThreadsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/',
    ...options,
  });

export const commentThreadsV3CreateCommentThread = <ThrowOnError extends boolean = true>(
  options?: Options<CommentThreadsV3CreateCommentThreadData, ThrowOnError>,
): RequestResult<CommentThreadsV3CreateCommentThreadResponses, unknown, ThrowOnError> =>
  (options?.client ?? client).post<CommentThreadsV3CreateCommentThreadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

export const commentThreadsV3ListTaggableUsers = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3ListTaggableUsersData, ThrowOnError>,
): RequestResult<CommentThreadsV3ListTaggableUsersResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CommentThreadsV3ListTaggableUsersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/taggable-users',
    ...options,
  });

export const commentThreadsV3DeleteCommentThread = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3DeleteCommentThreadData, ThrowOnError>,
): RequestResult<CommentThreadsV3DeleteCommentThreadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CommentThreadsV3DeleteCommentThreadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/{threadId}',
    ...options,
  });

export const commentThreadsV3GetCommentThread = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3GetCommentThreadData, ThrowOnError>,
): RequestResult<CommentThreadsV3GetCommentThreadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).get<CommentThreadsV3GetCommentThreadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/{threadId}',
    ...options,
  });

export const commentThreadsV3CreateComment = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3CreateCommentData, ThrowOnError>,
): RequestResult<CommentThreadsV3CreateCommentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CommentThreadsV3CreateCommentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/{threadId}/comments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const commentThreadsV3DeleteComment = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3DeleteCommentData, ThrowOnError>,
): RequestResult<CommentThreadsV3DeleteCommentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).delete<CommentThreadsV3DeleteCommentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/{threadId}/comments/{commentId}',
    ...options,
  });

export const commentThreadsV3UpdateComment = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3UpdateCommentData, ThrowOnError>,
): RequestResult<CommentThreadsV3UpdateCommentResponses, unknown, ThrowOnError> =>
  (options.client ?? client).patch<CommentThreadsV3UpdateCommentResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/{threadId}/comments/{commentId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const commentThreadsV3ResolveCommentThread = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3ResolveCommentThreadData, ThrowOnError>,
): RequestResult<CommentThreadsV3ResolveCommentThreadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CommentThreadsV3ResolveCommentThreadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/{threadId}/resolve',
    ...options,
  });

export const commentThreadsV3ReopenCommentThread = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3ReopenCommentThreadData, ThrowOnError>,
): RequestResult<CommentThreadsV3ReopenCommentThreadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CommentThreadsV3ReopenCommentThreadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/{threadId}/reopen',
    ...options,
  });

export const commentThreadsV3RestoreCommentThread = <ThrowOnError extends boolean = true>(
  options: Options<CommentThreadsV3RestoreCommentThreadData, ThrowOnError>,
): RequestResult<CommentThreadsV3RestoreCommentThreadResponses, unknown, ThrowOnError> =>
  (options.client ?? client).post<CommentThreadsV3RestoreCommentThreadResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v3/comment-threads/{threadId}/restore',
    ...options,
  });
